import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isWithinInterval, parse } from "date-fns";
import { toast, ToastContainer } from 'react-toastify';
import './TeacherReportSvc'
import 'common/css/master.css';
import Header from 'common/js/header/header.js';

// Dummy report data (use dd-MM-yyyy format as strings)
const dummyReportData = [
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "36/50"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "40/50"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "36/47"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "45/48"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "37/49"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "38/45"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "27/46"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "31/45"
  },
  {
    "date": "22-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "45/50"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "35/47"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/47"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "37/48"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "23/48"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "34/48"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "23/50"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/46"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "21/47"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "22/50"
  },
  {
    "date": "22-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "40/48"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "36/48"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/50"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "24/49"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/45"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "31/48"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "23/48"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "24/47"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "35/46"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "33/46"
  },
  {
    "date": "22-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "35/45"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "31/46"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "27/50"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "45/48"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "25/45"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "41/47"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "22/49"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/47"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "25/46"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "35/48"
  },
  {
    "date": "22-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "34/48"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "23/49"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "44/46"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "36/47"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "30/47"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "38/45"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "38/48"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "33/47"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "34/47"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "30/48"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "33/47"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "27/49"
  },
  {
    "date": "22-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/48"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/45"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/46"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "30/50"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "22/48"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "21/50"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "20/47"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "41/46"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "40/46"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/47"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "26/47"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "25/45"
  },
  {
    "date": "22-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "31/45"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "38/45"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "35/45"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "31/46"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "22/48"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "26/49"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "32/45"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "38/46"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/49"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "20/46"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "23/48"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "23/46"
  },
  {
    "date": "22-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "28/50"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "39/49"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "45/50"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "44/47"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "38/47"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "23/45"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "40/49"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "20/48"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "40/45"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "29/49"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "44/49"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "23/46"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "37/48"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "43/50"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "26/45"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "43/46"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "27/47"
  },
  {
    "date": "22-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "44/45"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "20/48"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "20/48"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/50"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "23/47"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "23/46"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "28/48"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "45/46"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "43/46"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "32/45"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "34/46"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "35/46"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/49"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "27/47"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "25/47"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/48"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "44/48"
  },
  {
    "date": "22-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/50"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "27/50"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/46"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/49"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "22/47"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "37/46"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "37/48"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "32/45"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "28/47"
  },
  {
    "date": "22-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/47"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "33/45"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/46"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "29/45"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "35/48"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "31/50"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "23/46"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "37/48"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "35/48"
  },
  {
    "date": "22-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "25/48"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "38/48"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "23/48"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/46"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "26/48"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "33/46"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "25/46"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "37/50"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "34/46"
  },
  {
    "date": "24-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "41/48"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "24/47"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "31/49"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "20/49"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "42/49"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "35/49"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "30/49"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/46"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "32/45"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "33/49"
  },
  {
    "date": "24-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "29/46"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "33/46"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "45/45"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "30/47"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "29/50"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "40/48"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "45/47"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "29/49"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "25/47"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "34/48"
  },
  {
    "date": "24-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "37/47"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "43/46"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "45/45"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "41/50"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "22/45"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "31/48"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "42/50"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/49"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "24/50"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "20/50"
  },
  {
    "date": "24-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/48"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "29/46"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/49"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "33/46"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "42/48"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "27/47"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "37/46"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/48"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "40/49"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "20/48"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "25/50"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "31/46"
  },
  {
    "date": "24-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "42/50"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "22/48"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "37/50"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "20/49"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "35/46"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "24/50"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "29/48"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "37/48"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "27/48"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "32/48"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "29/47"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "37/46"
  },
  {
    "date": "24-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "24/48"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "23/46"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "36/46"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "25/49"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "45/50"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "41/46"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "43/49"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "42/48"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "28/49"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "33/45"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "29/48"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "22/50"
  },
  {
    "date": "24-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "26/49"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/48"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "24/46"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "26/47"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "40/47"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "40/49"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "44/46"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "43/45"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "39/49"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "21/48"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "39/49"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "38/47"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "24/48"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "34/46"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "33/50"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "23/49"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "38/50"
  },
  {
    "date": "24-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "33/46"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "21/49"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/47"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/50"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "29/45"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "32/50"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/49"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "39/47"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "45/49"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "30/46"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "26/47"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "37/50"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/46"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "33/48"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "32/46"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "38/49"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "45/49"
  },
  {
    "date": "24-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "37/47"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "37/48"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "23/48"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "33/46"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "45/45"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "38/45"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "32/49"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "25/49"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "25/49"
  },
  {
    "date": "24-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "20/50"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "37/49"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/50"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "27/45"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "20/46"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "30/48"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "24/47"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "42/50"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "42/50"
  },
  {
    "date": "24-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "20/49"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/46"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "43/50"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "44/50"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "33/48"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "27/46"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "43/46"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/47"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "42/46"
  },
  {
    "date": "25-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "35/46"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "32/49"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "28/47"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "23/45"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "33/47"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "21/50"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "43/49"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "35/46"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "45/45"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "29/48"
  },
  {
    "date": "25-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "38/50"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "36/46"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "20/50"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "29/46"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "20/47"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "27/47"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "22/47"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/50"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/49"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "22/49"
  },
  {
    "date": "25-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "36/46"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "31/46"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "39/45"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "25/47"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "22/45"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "37/47"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "38/46"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "40/46"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "33/47"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "27/49"
  },
  {
    "date": "25-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/46"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "35/49"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "21/50"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "44/46"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "28/48"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "24/50"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "39/50"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "26/48"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "26/48"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "21/50"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "39/46"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "40/50"
  },
  {
    "date": "25-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "39/46"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "39/46"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "44/49"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "34/47"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "38/46"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "41/45"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "22/49"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/47"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "44/48"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "43/50"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "42/49"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "25/48"
  },
  {
    "date": "25-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "32/50"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "30/49"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/49"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/47"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "24/49"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "40/46"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/46"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "30/49"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "39/49"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "30/48"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "31/47"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "42/45"
  },
  {
    "date": "25-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "43/49"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "33/50"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "41/49"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "32/49"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "45/49"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "45/49"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "32/46"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "36/47"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "35/48"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "23/47"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "36/45"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "41/48"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "32/50"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "20/49"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "40/48"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "43/45"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "24/47"
  },
  {
    "date": "25-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "45/48"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/49"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "39/50"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "41/45"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "43/49"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "36/45"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "42/45"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "26/48"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "45/46"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "22/50"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "22/46"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "26/47"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "36/47"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "29/46"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "45/47"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "34/49"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "39/45"
  },
  {
    "date": "25-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "41/49"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "43/47"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "32/48"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "22/46"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "21/46"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "28/48"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "24/50"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "40/45"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "38/48"
  },
  {
    "date": "25-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "31/46"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "26/48"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "29/49"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "38/46"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "38/49"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "40/45"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "39/48"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "40/50"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "35/48"
  },
  {
    "date": "25-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "26/47"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "23/49"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "20/45"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "35/48"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "29/50"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "39/45"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "37/47"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/50"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/49"
  },
  {
    "date": "26-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "31/49"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/50"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "36/45"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "37/46"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "34/49"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "33/45"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "44/49"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/46"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "35/47"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "20/46"
  },
  {
    "date": "26-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/49"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "27/50"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "42/50"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "40/50"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "26/47"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "33/47"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "25/47"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "24/48"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "21/50"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "44/49"
  },
  {
    "date": "26-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "23/46"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "45/46"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "43/47"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "45/48"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "32/50"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "41/50"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "26/46"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/46"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "41/47"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/47"
  },
  {
    "date": "26-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "27/50"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "35/47"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/50"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "31/48"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "35/47"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "28/46"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "24/47"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "24/46"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "27/49"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "29/50"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "42/47"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "37/45"
  },
  {
    "date": "26-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/48"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "43/46"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "31/45"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "26/47"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "42/48"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "40/47"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "30/50"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "43/49"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "41/46"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "27/45"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "40/48"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "41/49"
  },
  {
    "date": "26-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "42/49"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "26/49"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/47"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "31/48"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "41/50"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "31/48"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "24/49"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "20/47"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/47"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "40/49"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "42/46"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "37/45"
  },
  {
    "date": "26-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/48"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "34/45"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "32/47"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/49"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "21/45"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "38/47"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "39/46"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "33/45"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "45/49"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "22/48"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "37/50"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "43/45"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/47"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "43/47"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "21/46"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "36/45"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "36/50"
  },
  {
    "date": "26-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "22/50"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "40/46"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "22/45"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "35/49"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "28/49"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "44/46"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "22/47"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "38/49"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "29/46"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "35/47"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "37/48"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "36/45"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "32/45"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "35/45"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "25/45"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "43/50"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "33/48"
  },
  {
    "date": "26-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "20/48"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/48"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "33/49"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "24/49"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "30/48"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "20/50"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "38/45"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "20/49"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "41/46"
  },
  {
    "date": "26-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "36/47"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/45"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/46"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "41/48"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "44/48"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "38/50"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "45/50"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "25/45"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "25/48"
  },
  {
    "date": "26-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/48"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "27/45"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "29/47"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "33/46"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "39/49"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "22/49"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "41/49"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/46"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "20/47"
  },
  {
    "date": "27-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "29/47"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "42/49"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "25/47"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "30/47"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "22/50"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "25/50"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "41/46"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/45"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "31/47"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "26/50"
  },
  {
    "date": "27-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "31/45"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "29/50"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "39/48"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "29/45"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "21/49"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "44/46"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "39/47"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/49"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "32/45"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/47"
  },
  {
    "date": "27-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "29/48"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "26/49"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/46"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "29/45"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "27/50"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "20/48"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "44/47"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/45"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/47"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/50"
  },
  {
    "date": "27-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "43/45"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "31/46"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "35/49"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "32/45"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "35/49"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "33/47"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "20/46"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "44/45"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "21/46"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "44/46"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "20/45"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "34/48"
  },
  {
    "date": "27-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "20/48"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "32/50"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/47"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "29/45"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/48"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "27/50"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "29/45"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "42/50"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "26/47"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/48"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "44/45"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "34/48"
  },
  {
    "date": "27-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "34/48"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "28/50"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "31/48"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "29/49"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/49"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "43/50"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "20/48"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/46"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "32/50"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/49"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "33/47"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "20/50"
  },
  {
    "date": "27-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "39/46"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "31/46"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/46"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "43/46"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "40/47"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "42/49"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "36/45"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "29/46"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "20/50"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "39/49"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "38/46"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "23/49"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/45"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/49"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "41/49"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/50"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "24/47"
  },
  {
    "date": "27-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "36/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "44/47"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "24/45"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "43/48"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "30/47"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "40/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "28/50"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "41/50"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "29/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "38/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "33/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/46"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "24/45"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "34/50"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "44/49"
  },
  {
    "date": "27-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "30/45"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "39/45"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "45/50"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "23/48"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "35/49"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "30/47"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "31/49"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "32/48"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "44/45"
  },
  {
    "date": "27-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/48"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "32/48"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "26/49"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "29/45"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "39/48"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "34/50"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "26/50"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "32/47"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "28/48"
  },
  {
    "date": "27-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "27/47"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "20/47"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/45"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "27/50"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "30/45"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "21/48"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "33/48"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "33/48"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "23/45"
  },
  {
    "date": "28-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "23/47"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "28/45"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "45/45"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/48"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "44/45"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "23/46"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "24/48"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/50"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "38/50"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/50"
  },
  {
    "date": "28-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "42/45"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "22/49"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "38/49"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "28/45"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "25/47"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "23/47"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "28/50"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "28/47"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "31/47"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "39/50"
  },
  {
    "date": "28-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "27/47"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "37/45"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "41/46"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "29/46"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "21/46"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "41/46"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "36/49"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/46"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "40/49"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "38/46"
  },
  {
    "date": "28-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/50"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "32/48"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "43/45"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/45"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "27/46"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "27/50"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "38/45"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "40/50"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "38/46"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "28/47"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "24/47"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "35/48"
  },
  {
    "date": "28-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "44/45"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "41/50"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "24/47"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "31/46"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/45"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "25/46"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "21/45"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/50"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "27/46"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "34/50"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "42/46"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "31/49"
  },
  {
    "date": "28-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "33/45"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "29/46"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/46"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "43/48"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "36/49"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "33/45"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "41/49"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/48"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "36/46"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "21/48"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/46"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "39/47"
  },
  {
    "date": "28-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/49"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "29/48"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "29/45"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "37/47"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "34/45"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "34/49"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "29/48"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "44/45"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "21/46"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "23/50"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "37/45"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "21/50"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/47"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "27/48"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "39/49"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "39/47"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "35/47"
  },
  {
    "date": "28-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "28/50"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/45"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "40/45"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/49"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "35/45"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "43/49"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "22/47"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "36/47"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "22/46"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "23/46"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "34/45"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "24/48"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "24/50"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "43/48"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "43/49"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "35/49"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/49"
  },
  {
    "date": "28-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "41/47"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "39/45"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "29/50"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/46"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "21/49"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "41/45"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "44/49"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "42/45"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "32/46"
  },
  {
    "date": "28-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "43/46"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "32/49"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "36/47"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "33/45"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "45/45"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "29/47"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "35/50"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "29/45"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "23/45"
  },
  {
    "date": "28-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "36/47"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/49"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/50"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "34/45"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/48"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "21/49"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "37/49"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/47"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "25/46"
  },
  {
    "date": "29-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "31/48"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "45/48"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "39/48"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "43/45"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "25/49"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "22/45"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "39/49"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/46"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/45"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/47"
  },
  {
    "date": "29-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "25/45"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "27/47"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "43/46"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "26/50"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "26/49"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "22/46"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "37/46"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "37/49"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "39/49"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "34/49"
  },
  {
    "date": "29-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "34/45"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "42/45"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "22/47"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "45/45"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/47"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "24/49"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "27/46"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "22/45"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "36/45"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "33/48"
  },
  {
    "date": "29-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "36/50"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "21/48"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "36/45"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "21/46"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "23/46"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "41/48"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "26/45"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "26/47"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "31/50"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "28/45"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "29/47"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "30/50"
  },
  {
    "date": "29-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "27/45"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "30/46"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "32/46"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "40/47"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "20/45"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "26/45"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "35/50"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "40/46"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "22/45"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "37/47"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "25/49"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "20/49"
  },
  {
    "date": "29-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "39/50"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "22/49"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "35/50"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/50"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "37/48"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "21/46"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "39/47"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/47"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "31/48"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "42/47"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "30/47"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "40/48"
  },
  {
    "date": "29-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "45/49"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "31/47"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/50"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "34/45"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "26/50"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "43/48"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "21/49"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "22/49"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "36/50"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "42/46"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "41/45"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "30/49"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "30/47"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "27/45"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "45/49"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "27/48"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "30/47"
  },
  {
    "date": "29-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "23/48"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/45"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "40/46"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "40/50"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "37/48"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "40/49"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "37/47"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "24/50"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "38/49"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "35/48"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "34/49"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "28/50"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/50"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "36/46"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "40/45"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/46"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "23/47"
  },
  {
    "date": "29-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "39/45"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "36/45"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "24/47"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "35/48"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "40/46"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "34/48"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "32/47"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "30/45"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "20/45"
  },
  {
    "date": "29-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "27/50"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/50"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/49"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "23/50"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "22/45"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "29/47"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "21/45"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "44/50"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "41/50"
  },
  {
    "date": "29-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/49"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "24/45"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/46"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "29/50"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "27/45"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "21/49"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "30/45"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/50"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "38/50"
  },
  {
    "date": "31-03-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "42/46"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "44/47"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "34/49"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "33/45"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "32/47"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "38/45"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "34/49"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/50"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "27/49"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/47"
  },
  {
    "date": "31-03-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/45"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "36/48"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "31/46"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "28/49"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/47"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "22/50"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "21/47"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "23/48"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "33/48"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "43/50"
  },
  {
    "date": "31-03-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/48"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "29/46"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "26/46"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "32/50"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "24/46"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "28/50"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "31/48"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/47"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "40/47"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "27/47"
  },
  {
    "date": "31-03-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "27/49"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "36/47"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "22/50"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/49"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "37/47"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "28/49"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "28/46"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "30/47"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "20/46"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "22/47"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "27/46"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "43/50"
  },
  {
    "date": "31-03-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "37/45"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "36/48"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "44/46"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "34/48"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "36/48"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "25/46"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "30/48"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "42/49"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "30/50"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "31/46"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "45/49"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "32/50"
  },
  {
    "date": "31-03-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "28/46"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "20/48"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "35/45"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "44/48"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "42/45"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "24/49"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "43/50"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/48"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "31/49"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "37/48"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "45/45"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "20/46"
  },
  {
    "date": "31-03-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "27/46"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "36/45"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/48"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "26/47"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/46"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "27/48"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "27/46"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "41/47"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "41/45"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "43/48"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "21/46"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "43/50"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "37/47"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/49"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "42/50"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "45/48"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "22/45"
  },
  {
    "date": "31-03-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "40/49"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "42/46"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/45"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/48"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "25/50"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "20/48"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "43/47"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "31/50"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "36/47"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "42/48"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "34/46"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "34/49"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/48"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "27/47"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "39/48"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/45"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "31/48"
  },
  {
    "date": "31-03-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/45"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "43/47"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/46"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/47"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/48"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "27/46"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "21/46"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "33/49"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "22/45"
  },
  {
    "date": "31-03-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/45"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/47"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "30/48"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "33/46"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/45"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "29/46"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "27/46"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "35/47"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "41/49"
  },
  {
    "date": "31-03-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/45"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "24/46"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "27/47"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "35/45"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "39/48"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "34/49"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "32/45"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "41/49"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "42/47"
  },
  {
    "date": "01-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "26/50"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "31/50"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "25/46"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "45/50"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "27/45"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "39/49"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "41/48"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/49"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "44/50"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "40/45"
  },
  {
    "date": "01-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "45/45"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "21/46"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "35/49"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "31/50"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "33/45"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "39/47"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "29/48"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "35/50"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "24/50"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "38/46"
  },
  {
    "date": "01-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "26/45"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "34/48"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/45"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "40/50"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "35/47"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "45/45"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "27/48"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "29/50"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "33/49"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "44/47"
  },
  {
    "date": "01-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "39/47"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "25/46"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/45"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "25/50"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "36/50"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "35/48"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "28/47"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "23/48"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "22/47"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "22/47"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/47"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "21/49"
  },
  {
    "date": "01-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "43/49"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "26/45"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/48"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/47"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "27/50"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "45/50"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "24/48"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/49"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "45/48"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "28/46"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "22/48"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "40/46"
  },
  {
    "date": "01-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "33/47"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "42/50"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "44/50"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/46"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "43/49"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "20/48"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "25/50"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "29/50"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "29/49"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "24/48"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "37/49"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "36/47"
  },
  {
    "date": "01-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "44/46"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "39/50"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "37/48"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "35/47"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "20/47"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "34/48"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "38/47"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "22/50"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "45/45"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "30/50"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "31/46"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "34/48"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/45"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "41/47"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "43/48"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "20/50"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "27/46"
  },
  {
    "date": "01-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/46"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/46"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "43/49"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/48"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "31/45"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "20/48"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "43/50"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "31/47"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "23/47"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "40/48"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "29/50"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "41/50"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/47"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "36/48"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "41/49"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "34/48"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "37/45"
  },
  {
    "date": "01-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "26/50"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "41/49"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "29/45"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/50"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "30/49"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "32/50"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "30/45"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "24/49"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "32/46"
  },
  {
    "date": "01-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "27/50"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "45/48"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "22/50"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "31/45"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "41/50"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "39/50"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "20/48"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "42/49"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "22/49"
  },
  {
    "date": "01-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "40/45"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "27/48"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "29/50"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "28/45"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "28/50"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "45/48"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "42/46"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "30/49"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "42/48"
  },
  {
    "date": "02-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "39/49"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "41/48"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "34/46"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "24/47"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "27/50"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "43/50"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "35/49"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "26/47"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "34/47"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/48"
  },
  {
    "date": "02-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "21/49"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "21/46"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "28/46"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "20/45"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "21/49"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "41/48"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "24/48"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/47"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "44/46"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "27/49"
  },
  {
    "date": "02-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "30/48"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "45/45"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "44/47"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "21/45"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "45/47"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "42/47"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "39/46"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/49"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "36/45"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "25/49"
  },
  {
    "date": "02-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "24/49"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "29/49"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "27/46"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "35/46"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "20/47"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "41/45"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "40/45"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "33/48"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "32/50"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "33/49"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "43/46"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "39/49"
  },
  {
    "date": "02-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "34/45"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/46"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "40/47"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "31/50"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "32/45"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "39/46"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "23/49"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/46"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "30/48"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "20/49"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "35/49"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "41/47"
  },
  {
    "date": "02-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "39/49"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "30/45"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "41/49"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/49"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "41/49"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "27/45"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "24/50"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "33/46"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "30/47"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "24/50"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "32/47"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "24/49"
  },
  {
    "date": "02-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "23/45"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "33/47"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/46"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "30/50"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "44/46"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "43/45"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "21/46"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "42/49"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "22/48"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "23/47"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "37/46"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "29/50"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/48"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "34/49"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "45/50"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "27/49"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/49"
  },
  {
    "date": "02-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/47"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "38/47"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "29/50"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/50"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/46"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "25/46"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "45/46"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "38/48"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "21/46"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "28/46"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "22/48"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "27/45"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/46"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "32/49"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "23/47"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "41/47"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "31/45"
  },
  {
    "date": "02-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "25/50"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "34/50"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/47"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/50"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "34/49"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "21/49"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "20/45"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "21/48"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "21/50"
  },
  {
    "date": "02-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "22/45"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "42/46"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/50"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/49"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "28/48"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "33/48"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "23/45"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "41/47"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "36/47"
  },
  {
    "date": "02-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "40/50"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "26/46"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/48"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "23/46"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "21/50"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "41/45"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "41/50"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/45"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "34/45"
  },
  {
    "date": "03-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "23/49"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "43/45"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "35/50"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "20/47"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "36/50"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "32/45"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "32/49"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "27/48"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "30/46"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/46"
  },
  {
    "date": "03-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "25/47"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "29/46"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "43/47"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "39/50"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "30/49"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "20/49"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "37/45"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "22/50"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "24/47"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "20/48"
  },
  {
    "date": "03-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "44/48"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "34/45"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "27/50"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "30/50"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/48"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "31/50"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "44/50"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/47"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "38/49"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "35/45"
  },
  {
    "date": "03-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "35/49"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "32/48"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "42/47"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "20/45"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "36/49"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "22/49"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "35/49"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "21/45"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "21/48"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "37/49"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "26/47"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "37/46"
  },
  {
    "date": "03-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "35/47"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "22/45"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/48"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "25/46"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "29/47"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "33/45"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "32/46"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "41/45"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "29/47"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "40/47"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "21/50"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "44/47"
  },
  {
    "date": "03-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "25/49"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "20/49"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "20/49"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "27/48"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "39/47"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "25/47"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "30/46"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/45"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "27/45"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "35/50"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "43/45"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "36/46"
  },
  {
    "date": "03-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "26/49"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/45"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/49"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/49"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "44/46"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "26/47"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "25/46"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "44/47"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "34/50"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "40/48"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "40/45"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "27/46"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/48"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "33/46"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "31/45"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/48"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "43/50"
  },
  {
    "date": "03-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "29/45"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "22/48"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "28/49"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/46"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "23/50"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "31/45"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "36/45"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "39/49"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "40/46"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "20/49"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "23/46"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "28/45"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "27/49"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "41/45"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "35/45"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/46"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "37/50"
  },
  {
    "date": "03-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/46"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "39/46"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/47"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "32/50"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "25/49"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "42/46"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "41/50"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "33/49"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "41/47"
  },
  {
    "date": "03-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/48"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "24/49"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "39/50"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/45"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "36/49"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "36/47"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "33/50"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "20/50"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "29/46"
  },
  {
    "date": "03-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/49"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "23/46"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/45"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "35/49"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "30/49"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "36/48"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "30/48"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "34/49"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "21/45"
  },
  {
    "date": "04-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/49"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "30/45"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "31/50"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "40/46"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/48"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "33/45"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "34/47"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/50"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "29/45"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "21/45"
  },
  {
    "date": "04-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "20/48"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "43/46"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "27/47"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "45/50"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "44/49"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "34/50"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "28/46"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "41/46"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/49"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/48"
  },
  {
    "date": "04-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/50"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "28/46"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "45/50"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/47"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/47"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "44/46"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "39/48"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/46"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/47"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "30/50"
  },
  {
    "date": "04-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "44/45"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/46"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "35/46"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "33/50"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "38/49"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "33/47"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "41/50"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/48"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "42/46"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "25/47"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "40/48"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "22/48"
  },
  {
    "date": "04-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "36/46"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "37/48"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/48"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "24/47"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "42/45"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "44/46"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "43/46"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/45"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "37/46"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "25/48"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "33/48"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "31/47"
  },
  {
    "date": "04-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "36/50"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "31/45"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/45"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "36/48"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/49"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "32/48"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "43/50"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/48"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/49"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "29/47"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "29/47"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "31/48"
  },
  {
    "date": "04-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/47"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "25/50"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "29/45"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "42/45"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "36/50"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "32/50"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "41/45"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "27/45"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "35/47"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "37/47"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "23/47"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "32/47"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "38/46"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "35/49"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "30/46"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "32/46"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "29/49"
  },
  {
    "date": "04-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "29/50"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "35/49"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "43/49"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "36/46"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "24/48"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "34/46"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "44/45"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "20/47"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "23/45"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "22/48"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "36/48"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "43/50"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "31/47"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "29/49"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/48"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "41/47"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "35/46"
  },
  {
    "date": "04-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "41/49"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "25/49"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "45/48"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "22/48"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "21/48"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "41/49"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "21/49"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "21/46"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "45/45"
  },
  {
    "date": "04-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/50"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "39/46"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "31/45"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "44/48"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "31/47"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "20/49"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "24/47"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "32/48"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "37/46"
  },
  {
    "date": "04-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "24/47"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "20/46"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "43/48"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "42/47"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "40/45"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "27/50"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "28/47"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/48"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "34/47"
  },
  {
    "date": "05-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "45/45"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "40/49"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "36/50"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "23/47"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "38/49"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "37/48"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "33/49"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "41/47"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/50"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "27/45"
  },
  {
    "date": "05-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "34/47"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "35/50"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/50"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "34/48"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "29/48"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "21/45"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "22/46"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/45"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "26/50"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "33/47"
  },
  {
    "date": "05-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "33/46"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "43/45"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "39/46"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "24/45"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/49"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "27/45"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "25/47"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "36/47"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "33/50"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "22/49"
  },
  {
    "date": "05-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "41/45"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "24/50"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "39/48"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "32/50"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "22/49"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "37/46"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "32/48"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "25/48"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "27/45"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "34/49"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "40/48"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "34/45"
  },
  {
    "date": "05-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/47"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "44/46"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "26/50"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/49"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "42/46"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "41/48"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "33/45"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "40/48"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "33/49"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "20/45"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "37/45"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "23/47"
  },
  {
    "date": "05-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "29/48"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "22/47"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/47"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "26/46"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "34/48"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "43/45"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "22/48"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/48"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "29/46"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/45"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "33/47"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "45/48"
  },
  {
    "date": "05-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "44/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "25/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/49"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "24/49"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "32/48"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "24/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "43/48"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "42/49"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "43/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "32/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "42/47"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/49"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/50"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "35/49"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "31/48"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "20/45"
  },
  {
    "date": "05-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "44/46"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/49"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "22/50"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "29/47"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "42/50"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "41/48"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "29/50"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "28/45"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "20/49"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "35/46"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "30/45"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "33/45"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/48"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "36/45"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "34/46"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "39/45"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "44/45"
  },
  {
    "date": "05-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "28/48"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "33/48"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "36/45"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "27/49"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "44/50"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "34/49"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "22/50"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "30/47"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "38/50"
  },
  {
    "date": "05-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/48"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/50"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "23/50"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/50"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/45"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "40/48"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "21/50"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "34/47"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "45/49"
  },
  {
    "date": "05-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/46"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "20/50"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "31/46"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "20/50"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/46"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "43/45"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "21/46"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/47"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "41/46"
  },
  {
    "date": "07-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "43/50"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "21/45"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "28/50"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "38/46"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "41/49"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "27/47"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "27/46"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/48"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "29/47"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "35/49"
  },
  {
    "date": "07-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "43/50"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "42/50"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/45"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "40/49"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "29/48"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "23/49"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "33/47"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "37/45"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "38/47"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/46"
  },
  {
    "date": "07-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/49"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "29/48"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "36/46"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "25/48"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "37/48"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "32/45"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "35/50"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/47"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "20/45"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "33/48"
  },
  {
    "date": "07-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "44/50"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "27/50"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "21/50"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/50"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/47"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "33/46"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "41/47"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/47"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "44/50"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "32/46"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "29/46"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "37/46"
  },
  {
    "date": "07-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "41/48"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "25/45"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "31/48"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/48"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "40/48"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "32/48"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "39/48"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "30/50"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "27/47"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "31/46"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "38/49"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "27/47"
  },
  {
    "date": "07-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "33/48"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "20/50"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/46"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "36/45"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "25/45"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "23/46"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "42/48"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/49"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "24/49"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "21/47"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "45/47"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "24/47"
  },
  {
    "date": "07-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "37/49"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "36/50"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "42/50"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/46"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "41/50"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "38/47"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "24/45"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "33/46"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "35/45"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "45/45"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "21/50"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "45/46"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "27/47"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "40/50"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "41/50"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/46"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "43/48"
  },
  {
    "date": "07-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "21/49"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "20/49"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "43/45"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "24/50"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "25/48"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "39/46"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "38/46"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "42/48"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "44/47"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "41/49"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "40/48"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "41/46"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/48"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "31/50"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "36/47"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "36/49"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "39/48"
  },
  {
    "date": "07-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "20/48"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "40/46"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "20/45"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/47"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "34/47"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "31/47"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "22/47"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "33/46"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "22/50"
  },
  {
    "date": "07-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/50"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "36/47"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "37/45"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "43/49"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "30/48"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "33/46"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "39/45"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/47"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "23/47"
  },
  {
    "date": "07-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/50"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "21/49"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "32/45"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "23/47"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "20/47"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "30/50"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "35/50"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/47"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/50"
  },
  {
    "date": "08-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "22/45"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "35/48"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "41/49"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "43/47"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "31/49"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "24/46"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "23/46"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/49"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "38/50"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/49"
  },
  {
    "date": "08-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "27/48"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "37/45"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "36/46"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "33/49"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "26/50"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "44/45"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "29/50"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/46"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "33/48"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "27/47"
  },
  {
    "date": "08-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/45"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "42/47"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "44/46"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "28/45"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "34/48"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "23/45"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "42/50"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "42/50"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "25/47"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "38/46"
  },
  {
    "date": "08-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/45"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/48"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "35/47"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/45"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "28/46"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "25/47"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "37/48"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/47"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/49"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "28/46"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "43/47"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "38/46"
  },
  {
    "date": "08-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/46"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "24/49"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/48"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/49"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/45"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "28/48"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "21/48"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "24/50"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/45"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "36/48"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "21/45"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "42/50"
  },
  {
    "date": "08-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "44/47"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "32/50"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "24/46"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/49"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "24/50"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "37/46"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "39/47"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/47"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "37/50"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "27/45"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "22/47"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "33/49"
  },
  {
    "date": "08-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "21/50"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "45/47"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "32/49"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "25/48"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/47"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "30/45"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "44/50"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "28/47"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "29/45"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "25/46"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "35/46"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "27/49"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "20/48"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "27/46"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "21/48"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "36/48"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "24/47"
  },
  {
    "date": "08-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "39/49"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "21/48"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/48"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "30/47"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "41/50"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "37/47"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "44/49"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "36/46"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "39/46"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "22/50"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "38/50"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "44/45"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/48"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "34/46"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "34/48"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/46"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "21/46"
  },
  {
    "date": "08-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "24/45"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "25/45"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "35/45"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "44/49"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "40/50"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "24/47"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "23/45"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "23/49"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "27/45"
  },
  {
    "date": "08-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "43/50"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/50"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "23/45"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/48"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "41/49"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "41/47"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "43/47"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "30/47"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "41/46"
  },
  {
    "date": "08-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "28/50"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "42/50"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "37/47"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "45/45"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "24/45"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "41/45"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "44/50"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "36/46"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "35/49"
  },
  {
    "date": "09-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "23/45"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "21/49"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "28/47"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "23/49"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "32/50"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "32/48"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "30/46"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "25/45"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "38/50"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "34/49"
  },
  {
    "date": "09-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "23/47"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "28/45"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/47"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "29/48"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/50"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "39/50"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "27/45"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/50"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "22/49"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "39/48"
  },
  {
    "date": "09-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "37/47"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "34/46"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "35/45"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/49"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "36/46"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "23/46"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "35/49"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/49"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "23/46"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "34/45"
  },
  {
    "date": "09-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "43/47"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "24/46"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/47"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "23/49"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "40/49"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "45/45"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "23/49"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/48"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "38/49"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "25/47"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "42/46"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "27/48"
  },
  {
    "date": "09-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "32/46"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "31/50"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "29/48"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/46"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "36/49"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "37/49"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "33/47"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/45"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "43/46"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "32/47"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "34/47"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "40/46"
  },
  {
    "date": "09-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "31/48"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "30/45"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/48"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "25/46"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/47"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "25/45"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "29/48"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/48"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "26/47"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "27/49"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "26/48"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "28/49"
  },
  {
    "date": "09-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "21/50"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "20/46"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/46"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "29/50"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "37/49"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "24/50"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "20/50"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "28/50"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "37/48"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "38/45"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "24/49"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "21/45"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/48"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "29/48"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "31/49"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "28/46"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "26/50"
  },
  {
    "date": "09-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/46"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "43/45"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "42/45"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "20/46"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "22/45"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "44/46"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "36/49"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "34/45"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "26/48"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "44/49"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "41/47"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "32/49"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/45"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "27/45"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "45/47"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "21/47"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "23/47"
  },
  {
    "date": "09-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "38/49"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "24/45"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "38/46"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "44/45"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "36/49"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "37/47"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "39/46"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "41/48"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "42/47"
  },
  {
    "date": "09-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "34/45"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "39/48"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/47"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/45"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "21/47"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "27/46"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "32/45"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "30/48"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "39/49"
  },
  {
    "date": "09-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "35/49"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "34/49"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "32/46"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/48"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "27/47"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "41/46"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "34/48"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/48"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "32/47"
  },
  {
    "date": "10-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/45"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/49"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/47"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/47"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "21/50"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "32/48"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "24/47"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "30/49"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "36/46"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "35/46"
  },
  {
    "date": "10-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/48"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "42/46"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "20/49"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "36/49"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "39/48"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "36/45"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "33/50"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/45"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "39/45"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "33/46"
  },
  {
    "date": "10-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "33/49"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "40/49"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "37/46"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "26/45"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "26/47"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "28/45"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "23/46"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/49"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "31/47"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "34/46"
  },
  {
    "date": "10-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "34/50"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "28/46"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/47"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "35/49"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "39/45"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "34/50"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "21/49"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "40/45"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "43/48"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "43/49"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "41/49"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "32/50"
  },
  {
    "date": "10-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/49"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "28/49"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/46"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "39/48"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "20/45"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "30/50"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "25/49"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "33/46"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "36/49"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "42/49"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "39/47"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "34/48"
  },
  {
    "date": "10-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "35/45"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "29/46"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "28/49"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "24/49"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "38/45"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "43/46"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "31/46"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "41/47"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "31/49"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "37/49"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "42/48"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "29/49"
  },
  {
    "date": "10-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/48"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "29/46"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "22/47"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/48"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "39/49"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "33/50"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "42/49"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "30/47"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "37/50"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "29/48"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "45/49"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "31/47"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "38/46"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "39/45"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "44/47"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/47"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "32/49"
  },
  {
    "date": "10-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "35/50"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/46"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "35/45"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "23/47"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "44/47"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "42/50"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "21/48"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "31/50"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "36/49"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "43/45"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "45/48"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "26/50"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/50"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/50"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "35/46"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "34/46"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "27/48"
  },
  {
    "date": "10-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "36/48"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/50"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/46"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "36/50"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "24/50"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "23/46"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "28/50"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "36/48"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "27/48"
  },
  {
    "date": "10-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "33/48"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "37/45"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "34/47"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "32/47"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "20/49"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "30/48"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "40/47"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "34/49"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "31/47"
  },
  {
    "date": "10-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "26/46"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "29/48"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "38/50"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "33/48"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "31/48"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "35/45"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "33/49"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "45/48"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "23/49"
  },
  {
    "date": "11-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "25/50"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "45/48"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "44/49"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "29/49"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "34/50"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "45/49"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "34/46"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "21/50"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "21/45"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "34/47"
  },
  {
    "date": "11-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "25/50"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "30/50"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "36/47"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/48"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "39/48"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "31/45"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "31/48"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/49"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/48"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "26/50"
  },
  {
    "date": "11-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "30/47"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "29/46"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "43/47"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "35/46"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "27/46"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "21/50"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "31/45"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "42/45"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "28/45"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "44/50"
  },
  {
    "date": "11-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "25/48"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "39/48"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "45/47"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "22/50"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "40/50"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "28/50"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "29/50"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "20/50"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "42/47"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "22/47"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "32/49"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "43/48"
  },
  {
    "date": "11-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/50"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "42/46"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "33/50"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "20/46"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "42/46"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "27/46"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "24/48"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/48"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "20/47"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "25/47"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "36/47"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "25/50"
  },
  {
    "date": "11-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "33/45"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "20/47"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "38/45"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "34/48"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "23/46"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "36/49"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/48"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "44/49"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "37/46"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "25/49"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "35/49"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "35/46"
  },
  {
    "date": "11-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "37/45"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "31/45"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "32/45"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/49"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "42/47"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "41/47"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "38/45"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "30/50"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "23/50"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "39/47"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "45/47"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "42/49"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "31/50"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "27/48"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "32/48"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "24/45"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "20/49"
  },
  {
    "date": "11-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "24/48"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "26/50"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "45/48"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "39/48"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "32/50"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "21/46"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "29/45"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "32/50"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "36/49"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "22/50"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "45/47"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "37/45"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "28/50"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/48"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "36/46"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "45/45"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "25/48"
  },
  {
    "date": "11-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/47"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "39/49"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "32/49"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "36/49"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "23/48"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "36/46"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "35/45"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "22/50"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "32/50"
  },
  {
    "date": "11-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/49"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "43/47"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/49"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "42/47"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "22/47"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "32/46"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/49"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "41/48"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "42/46"
  },
  {
    "date": "11-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "38/45"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "34/48"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "34/45"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/45"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "21/45"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "40/48"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "35/46"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "33/49"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "41/48"
  },
  {
    "date": "12-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "40/46"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "42/45"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "26/46"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "44/45"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "35/47"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "28/46"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "29/50"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "33/45"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/48"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "38/47"
  },
  {
    "date": "12-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/48"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "22/50"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "22/50"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/49"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "37/50"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "43/46"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "20/50"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/46"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/47"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "28/45"
  },
  {
    "date": "12-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "35/49"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "32/48"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "27/46"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/48"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "32/49"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "20/49"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "42/47"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/50"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "30/50"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "28/45"
  },
  {
    "date": "12-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/48"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "40/48"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "38/45"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "25/46"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "37/49"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "35/46"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "44/47"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/47"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "32/45"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "33/50"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "24/50"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "32/45"
  },
  {
    "date": "12-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "33/48"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "37/45"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "20/49"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "43/45"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/45"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "35/45"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "22/49"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "29/45"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "43/49"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/50"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "43/50"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "22/49"
  },
  {
    "date": "12-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "28/47"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/49"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/48"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/50"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "39/45"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "44/49"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "34/50"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/46"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "36/47"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "32/46"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "22/48"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "29/47"
  },
  {
    "date": "12-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/48"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "26/49"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "30/46"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/46"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "38/45"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "40/48"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "41/45"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "38/49"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "45/45"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "26/46"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "44/46"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "35/45"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "25/46"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "39/48"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/49"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/49"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "43/50"
  },
  {
    "date": "12-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "41/49"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "31/50"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "26/45"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "38/47"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "40/46"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "36/48"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "42/47"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "40/46"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "43/47"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "35/50"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "37/50"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "34/48"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "43/46"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/46"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "20/46"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "30/47"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "32/49"
  },
  {
    "date": "12-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "32/49"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "36/49"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "22/48"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "23/46"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "26/46"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "23/45"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "39/45"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "31/50"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "22/45"
  },
  {
    "date": "12-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "36/50"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "37/50"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "32/48"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "36/47"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/45"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "28/45"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "30/46"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "34/50"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "21/49"
  },
  {
    "date": "12-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/45"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "42/50"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "32/49"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "22/47"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "42/45"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "40/48"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "21/50"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "38/46"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "33/46"
  },
  {
    "date": "14-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "37/48"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "37/50"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "44/50"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "32/48"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "35/45"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "45/49"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "36/50"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "44/50"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "32/48"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "30/49"
  },
  {
    "date": "14-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "39/45"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "29/45"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "37/46"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "23/47"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "30/49"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "22/48"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "45/50"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/45"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "24/47"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "20/46"
  },
  {
    "date": "14-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "24/49"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "26/48"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "44/47"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "27/50"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "26/49"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "40/50"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "23/48"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/47"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "20/49"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "32/45"
  },
  {
    "date": "14-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "43/48"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/48"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/45"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "26/48"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "23/45"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "32/49"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "29/50"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/49"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "41/45"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "39/45"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "35/50"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "33/45"
  },
  {
    "date": "14-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "36/49"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "42/50"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "26/45"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/46"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "21/46"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "31/46"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "25/47"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/48"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "40/50"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "21/48"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "31/49"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "36/46"
  },
  {
    "date": "14-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "26/49"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "31/48"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "40/46"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "21/45"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "20/48"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "35/46"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "20/50"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "21/49"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "37/46"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "39/46"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/45"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "29/48"
  },
  {
    "date": "14-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/50"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "25/45"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "42/46"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "45/45"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "44/46"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "32/48"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "22/47"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "29/48"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "25/50"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "24/49"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "20/48"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "39/47"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "26/50"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "36/46"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "41/49"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "23/46"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "39/48"
  },
  {
    "date": "14-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "36/45"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/50"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "35/49"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "45/48"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "21/50"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "27/45"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "24/48"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "34/45"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "28/46"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "42/49"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "20/46"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "38/50"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/46"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "31/50"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "28/46"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "31/50"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "40/47"
  },
  {
    "date": "14-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "45/50"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "33/47"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/46"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "26/46"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "40/46"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "21/50"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "23/48"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "20/49"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "21/49"
  },
  {
    "date": "14-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/50"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "34/45"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "36/49"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "21/46"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "29/49"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "21/46"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "43/45"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "24/50"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "26/50"
  },
  {
    "date": "14-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/48"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/47"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "24/49"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/46"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "20/45"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "21/45"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "24/47"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/48"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "31/46"
  },
  {
    "date": "15-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "29/47"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/46"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "42/45"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "35/46"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/45"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "34/49"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "45/50"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "39/47"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "44/47"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "30/46"
  },
  {
    "date": "15-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/50"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "21/45"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "33/46"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "44/48"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "42/46"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "35/46"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "33/49"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/48"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "31/50"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "35/50"
  },
  {
    "date": "15-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "43/49"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "41/47"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "42/48"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "22/45"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/48"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "27/50"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "41/48"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "29/48"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "25/49"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "44/45"
  },
  {
    "date": "15-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "44/47"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "41/48"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "23/46"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "26/45"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "45/45"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "28/48"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "24/49"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "27/46"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "42/48"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "29/50"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "45/47"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "30/45"
  },
  {
    "date": "15-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "41/49"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "45/48"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "34/50"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "32/50"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "37/50"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "40/49"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "40/47"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "41/50"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "35/48"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "27/50"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "39/48"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "42/46"
  },
  {
    "date": "15-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/46"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/46"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/45"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/47"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "34/48"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "44/47"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "35/46"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "37/49"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "41/47"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "20/45"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "33/47"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "27/45"
  },
  {
    "date": "15-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/50"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "26/50"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "27/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "29/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "21/45"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "30/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "34/45"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "27/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "42/47"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "27/47"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "37/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "44/45"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/47"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "39/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "30/46"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "40/47"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "30/48"
  },
  {
    "date": "15-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "39/47"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "36/48"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "23/49"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "39/47"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "26/47"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "32/45"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "26/50"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "43/45"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "38/48"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "43/45"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "42/45"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "36/47"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "29/50"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "45/48"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/46"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "32/48"
  },
  {
    "date": "15-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "25/47"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "29/47"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/47"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/49"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "33/47"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "39/49"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "28/46"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "21/46"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "24/47"
  },
  {
    "date": "15-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "25/49"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "31/46"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "30/45"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "37/49"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "32/46"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "23/49"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "32/48"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "44/49"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "31/45"
  },
  {
    "date": "15-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/50"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "29/48"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "37/47"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "31/50"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "21/49"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "26/45"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "27/50"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "31/46"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "45/45"
  },
  {
    "date": "16-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "44/46"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "42/50"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/49"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "36/45"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/45"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "26/49"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "24/48"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "23/49"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "21/45"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "24/50"
  },
  {
    "date": "16-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "38/49"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "32/45"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "34/46"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "36/50"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "31/46"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "38/49"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "34/45"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/45"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "39/47"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "43/48"
  },
  {
    "date": "16-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "38/49"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "26/46"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "22/50"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "42/45"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "45/45"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "31/47"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "44/49"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/45"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "37/48"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "32/50"
  },
  {
    "date": "16-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/47"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "35/50"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/45"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/47"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "44/47"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "43/50"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "25/50"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "39/45"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "22/45"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "33/49"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "39/45"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "25/49"
  },
  {
    "date": "16-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "22/49"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "35/48"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/48"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "44/46"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "31/49"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "45/49"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "31/48"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "37/50"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "20/45"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "41/45"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "20/49"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "31/46"
  },
  {
    "date": "16-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "38/50"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "20/48"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "21/45"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "38/50"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "30/48"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "29/45"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "31/46"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/50"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "38/50"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "43/48"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "28/46"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "28/47"
  },
  {
    "date": "16-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "20/49"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "37/47"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/47"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/49"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "30/46"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "32/48"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "29/49"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "42/45"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "31/45"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "30/48"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "42/47"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "21/45"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "44/45"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "35/46"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "28/49"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "37/49"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "43/50"
  },
  {
    "date": "16-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "34/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "30/50"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "30/45"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "40/46"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "26/50"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "40/50"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "33/50"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "41/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "22/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "33/50"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "33/48"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "34/49"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "43/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "41/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "26/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "23/47"
  },
  {
    "date": "16-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "20/46"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/50"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/48"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "22/46"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "25/45"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "25/47"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "41/47"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "39/46"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "34/45"
  },
  {
    "date": "16-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "23/47"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "45/47"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/48"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "29/49"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "44/50"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "22/49"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "36/46"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "27/45"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "41/45"
  },
  {
    "date": "16-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "30/48"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "30/49"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/46"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "30/45"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "37/46"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "28/48"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "29/45"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "27/45"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "34/50"
  },
  {
    "date": "17-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "23/48"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "30/46"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "20/47"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "38/48"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "28/45"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "20/50"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "24/46"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/48"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "28/48"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "28/47"
  },
  {
    "date": "17-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/49"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "27/46"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/48"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "26/46"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "42/45"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "29/49"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "28/47"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "41/48"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "39/45"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "36/48"
  },
  {
    "date": "17-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "21/48"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "45/46"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "36/46"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "44/49"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "24/47"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "39/45"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "20/50"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/48"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "21/49"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "36/45"
  },
  {
    "date": "17-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "44/46"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "43/49"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "28/49"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "37/49"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/49"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "36/46"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "28/45"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "20/47"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "41/48"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "34/46"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "35/49"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "29/47"
  },
  {
    "date": "17-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "28/48"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "24/50"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "34/46"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "22/45"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "30/45"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "21/47"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "25/47"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "39/47"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/49"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "22/46"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "32/45"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "34/50"
  },
  {
    "date": "17-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "28/49"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "34/47"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/49"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/49"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/47"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "31/50"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "21/48"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/48"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "20/48"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/50"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "42/46"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "36/46"
  },
  {
    "date": "17-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "38/45"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "24/47"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "23/46"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "23/50"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "44/45"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "39/48"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "27/50"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "20/48"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "25/47"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "22/50"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "39/45"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "32/50"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/45"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "41/46"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "29/46"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/48"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "28/50"
  },
  {
    "date": "17-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "21/48"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "36/45"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "32/50"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "20/50"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "24/47"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "41/50"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "39/45"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "20/46"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "26/45"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "42/50"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "30/49"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "39/45"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "32/47"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "34/45"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "23/46"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "34/46"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "29/47"
  },
  {
    "date": "17-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "38/46"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "32/47"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/49"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "43/45"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "45/49"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "24/48"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "29/45"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "31/48"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "44/49"
  },
  {
    "date": "17-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "29/50"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/48"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/46"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/50"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "42/46"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "43/48"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "30/48"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "43/50"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "20/47"
  },
  {
    "date": "17-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "41/50"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/45"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "42/45"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "44/47"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "20/45"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "40/46"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "42/45"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "38/45"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "36/48"
  },
  {
    "date": "18-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "42/50"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "44/50"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "32/48"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "29/48"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/48"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "31/49"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "20/49"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "40/48"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "37/49"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "22/46"
  },
  {
    "date": "18-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/50"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/46"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "28/45"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "40/48"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/49"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "22/45"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "21/47"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/46"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "25/45"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "38/49"
  },
  {
    "date": "18-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "25/47"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "24/50"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "43/50"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "39/45"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "45/49"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "35/50"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "23/47"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "31/49"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "28/46"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "37/47"
  },
  {
    "date": "18-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "25/48"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "43/48"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "27/45"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "22/48"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "43/50"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "35/46"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "42/47"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "31/48"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "38/49"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "33/46"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "45/48"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "23/45"
  },
  {
    "date": "18-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "20/46"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "22/46"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "45/47"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "24/49"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "32/48"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "27/45"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "28/50"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/49"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "22/50"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "27/48"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "29/49"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "42/45"
  },
  {
    "date": "18-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/46"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "41/49"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "26/50"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/47"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "38/49"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "42/49"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "43/45"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/49"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/46"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "32/48"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "27/45"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "34/46"
  },
  {
    "date": "18-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "27/50"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "42/46"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/48"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "43/49"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "29/49"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "22/46"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "24/49"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "36/49"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "30/50"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "25/46"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "27/48"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "42/45"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "30/50"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/46"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "28/47"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/50"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "42/47"
  },
  {
    "date": "18-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "38/45"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "38/46"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "39/49"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/48"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "39/49"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "25/49"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "34/49"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "29/49"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "45/50"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "22/48"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "25/46"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "39/47"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/46"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "25/45"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "26/46"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "45/47"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "40/45"
  },
  {
    "date": "18-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "34/45"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/50"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "23/47"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "36/49"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "39/50"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "44/45"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "44/46"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "27/48"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "32/49"
  },
  {
    "date": "18-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "25/45"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "31/50"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/49"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "24/50"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "20/47"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "24/48"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "42/47"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "44/46"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "31/47"
  },
  {
    "date": "18-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/45"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "20/46"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "26/46"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "39/46"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "32/47"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "25/45"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "32/50"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "42/47"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "35/48"
  },
  {
    "date": "19-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "37/45"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "27/45"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "23/46"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "42/49"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "34/46"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "37/47"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "22/45"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "45/50"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "37/47"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "29/50"
  },
  {
    "date": "19-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "30/46"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "32/45"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "43/45"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "20/48"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "28/45"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "45/45"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "35/50"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "23/49"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "36/49"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "38/48"
  },
  {
    "date": "19-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "34/50"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "32/48"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "36/46"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "24/47"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "29/47"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "37/50"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "25/50"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/48"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "35/50"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/47"
  },
  {
    "date": "19-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "43/45"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "36/46"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/46"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "28/45"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "22/46"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "45/50"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "32/50"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "39/47"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "32/48"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "21/50"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "33/46"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "20/48"
  },
  {
    "date": "19-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "33/47"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "33/49"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "30/49"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "41/50"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "36/47"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "22/47"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "26/45"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "40/48"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "38/45"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "37/49"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "45/50"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "43/47"
  },
  {
    "date": "19-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "34/50"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "30/49"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "35/48"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "26/45"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "38/50"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "40/50"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "39/49"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "27/48"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "27/45"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "39/46"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "39/46"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "39/50"
  },
  {
    "date": "19-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "29/45"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "43/45"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "37/46"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "35/48"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "26/48"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "34/50"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/47"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "34/48"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "29/49"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "41/50"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "23/50"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "41/45"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/50"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "28/45"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "40/48"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/46"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "40/49"
  },
  {
    "date": "19-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "25/49"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/47"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/48"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/48"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "37/49"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "40/48"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "25/50"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "21/46"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "35/47"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "44/45"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "42/46"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "21/46"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "27/45"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/50"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "42/45"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "21/50"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "30/49"
  },
  {
    "date": "19-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "30/48"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "33/46"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "28/45"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "22/48"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "21/47"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "38/48"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "41/50"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "22/49"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "40/48"
  },
  {
    "date": "19-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "30/46"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "21/50"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/46"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/45"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "44/50"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "26/46"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "42/50"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "45/45"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "31/47"
  },
  {
    "date": "19-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "37/45"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "37/49"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "25/50"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "39/46"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "39/50"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "37/48"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "31/46"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "33/46"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "21/46"
  },
  {
    "date": "21-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "28/49"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "29/48"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/50"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "33/48"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/48"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "42/46"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "28/47"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "44/47"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "41/50"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "21-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "37/50"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "42/50"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "40/50"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "37/45"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "36/49"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "44/46"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "29/45"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "39/47"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "39/45"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "28/48"
  },
  {
    "date": "21-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "29/45"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "39/50"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "23/45"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "44/45"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "28/50"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "20/45"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "33/47"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/49"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "40/50"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "32/50"
  },
  {
    "date": "21-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "25/47"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "43/49"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "39/47"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "23/46"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "45/49"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "32/50"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "45/49"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "33/47"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "41/50"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "20/49"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "28/49"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "40/47"
  },
  {
    "date": "21-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "43/50"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "45/47"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "41/48"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "32/48"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "33/45"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "42/46"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "44/48"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/50"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "42/50"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "35/45"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "42/47"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "31/48"
  },
  {
    "date": "21-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "39/47"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "36/46"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "31/47"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/48"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "43/49"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "32/48"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "24/48"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/46"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "22/50"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "31/49"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "21/46"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "37/50"
  },
  {
    "date": "21-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/48"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "41/50"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "29/45"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "27/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "41/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "28/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "39/45"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "21/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "21/45"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "21/50"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "38/50"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "33/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/50"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "41/48"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "33/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "44/46"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "45/49"
  },
  {
    "date": "21-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "20/50"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "20/45"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/47"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/50"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "38/46"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "31/48"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "24/48"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "45/49"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "38/48"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "30/49"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "26/45"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "26/50"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "22/47"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "40/49"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "35/49"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "45/47"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "39/46"
  },
  {
    "date": "21-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/49"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "31/50"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/46"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "30/49"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "35/45"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "32/50"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "41/49"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "25/45"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "20/49"
  },
  {
    "date": "21-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/46"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "26/45"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "28/50"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "26/45"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "20/49"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "38/48"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "31/46"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "32/49"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "42/48"
  },
  {
    "date": "21-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "38/45"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "41/46"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "20/47"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "24/46"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "34/47"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "35/45"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "40/49"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/49"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "26/46"
  },
  {
    "date": "22-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "27/49"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "20/50"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/50"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "24/48"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "33/46"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "34/50"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "36/45"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/45"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "27/47"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "25/49"
  },
  {
    "date": "22-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "34/47"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "41/45"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "33/50"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/47"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/45"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "22/48"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "44/46"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "44/50"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "21/49"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "42/47"
  },
  {
    "date": "22-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "41/48"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "37/49"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "31/47"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "36/47"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "30/48"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "41/50"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "26/47"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "38/45"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "36/47"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "22/48"
  },
  {
    "date": "22-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/46"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "45/49"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "21/46"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/50"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "28/46"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "26/50"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "24/46"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "41/47"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "42/45"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "24/46"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "25/49"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "20/48"
  },
  {
    "date": "22-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "28/48"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "29/47"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "25/45"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "31/46"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "38/50"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "30/46"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "33/46"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "36/45"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/48"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "27/48"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "38/47"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "39/46"
  },
  {
    "date": "22-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "40/46"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "40/50"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/45"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "38/50"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "27/49"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "44/47"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "26/46"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/47"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "31/48"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "21/48"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "20/46"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "42/50"
  },
  {
    "date": "22-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "45/47"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "35/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "37/45"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "41/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "30/47"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "39/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "34/49"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "24/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "42/50"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "25/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "35/45"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "21/48"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "43/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "26/46"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/45"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "33/45"
  },
  {
    "date": "22-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "45/49"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "20/49"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "38/46"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/47"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "26/50"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "22/49"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "45/47"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "22/47"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "37/49"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "37/49"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "33/46"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "31/48"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "41/46"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "44/45"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "40/45"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "31/46"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "25/47"
  },
  {
    "date": "22-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "26/45"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "30/45"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "36/48"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "38/46"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "31/50"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "35/49"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "35/45"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "26/49"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "43/45"
  },
  {
    "date": "22-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "44/49"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "21/50"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "22/50"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/46"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "22/45"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "38/47"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "44/50"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "31/50"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "38/48"
  },
  {
    "date": "22-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "36/50"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "24/45"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "33/50"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "31/46"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "24/47"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "25/45"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "22/49"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/48"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "40/47"
  },
  {
    "date": "23-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "20/45"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "25/47"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "36/46"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "28/50"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/47"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "35/49"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "42/46"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "27/50"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "35/50"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "24/50"
  },
  {
    "date": "23-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "30/50"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "41/45"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "40/46"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "22/48"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "41/48"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "20/47"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "32/45"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "31/45"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "24/46"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "38/49"
  },
  {
    "date": "23-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "37/46"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "36/49"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "23/45"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "35/47"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "34/50"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "29/47"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "44/45"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "37/46"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "39/47"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/46"
  },
  {
    "date": "23-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "36/48"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "34/48"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "35/47"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "21/49"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "25/45"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "30/46"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "38/50"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "44/50"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "40/45"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "39/49"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "38/50"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "43/50"
  },
  {
    "date": "23-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "34/45"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "32/46"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "26/50"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/48"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "38/50"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "26/48"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "37/48"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "29/50"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/50"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "35/47"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/49"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "31/46"
  },
  {
    "date": "23-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/46"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "31/47"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "33/47"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "30/49"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "40/46"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "20/45"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "30/47"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "45/45"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "20/49"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "44/48"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "45/45"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "35/46"
  },
  {
    "date": "23-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "25/47"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "29/48"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "20/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "34/49"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "31/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "40/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "23/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "28/49"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "30/48"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "23/50"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "36/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "28/48"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "41/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "30/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "38/47"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "34/45"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "30/49"
  },
  {
    "date": "23-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "44/48"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "40/46"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "27/46"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/46"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "27/49"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "30/45"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "21/49"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "40/47"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "23/46"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "26/47"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "22/50"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "44/50"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/49"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "32/45"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "41/49"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/48"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "30/46"
  },
  {
    "date": "23-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "40/48"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "37/49"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "23/49"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/50"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "23/47"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "32/46"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "31/49"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "23/49"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "22/49"
  },
  {
    "date": "23-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "32/46"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "36/50"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/47"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "26/46"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "41/45"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "22/50"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "33/47"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "36/49"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "23/46"
  },
  {
    "date": "23-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "28/46"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "33/47"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "33/50"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "38/49"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "32/46"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "20/45"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "28/49"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "20/45"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "32/45"
  },
  {
    "date": "24-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "27/48"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "25/46"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "28/46"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "42/48"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "23/48"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "22/46"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "33/48"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/50"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "38/46"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/46"
  },
  {
    "date": "24-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "28/50"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "33/47"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "23/49"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "26/46"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "30/49"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "38/46"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "35/48"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "42/47"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/50"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/48"
  },
  {
    "date": "24-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/48"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "27/48"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "23/46"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "26/49"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "33/48"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "26/50"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "31/49"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/45"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "29/45"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/46"
  },
  {
    "date": "24-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "33/48"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "39/49"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "36/45"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "30/47"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "34/45"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "20/49"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "40/50"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "27/50"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "32/45"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/45"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "45/50"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "22/48"
  },
  {
    "date": "24-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "32/47"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "21/46"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/49"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "26/49"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "38/46"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "27/46"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "39/47"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "26/49"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "21/49"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "38/46"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "33/48"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "23/45"
  },
  {
    "date": "24-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "30/45"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "40/48"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/49"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "40/46"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "26/50"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "20/49"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "32/47"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/48"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "34/50"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "44/48"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "22/46"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "45/48"
  },
  {
    "date": "24-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "30/45"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "38/49"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "31/45"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/45"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "24/45"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "29/50"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "36/48"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "32/47"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "27/49"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "44/49"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "25/46"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "29/47"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "23/50"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "33/45"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "26/46"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "21/45"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "42/50"
  },
  {
    "date": "24-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/49"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "38/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "36/50"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "34/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "38/46"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "20/47"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "30/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "45/45"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "26/46"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "30/50"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "28/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "27/46"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "20/48"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "29/45"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "43/49"
  },
  {
    "date": "24-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "29/50"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "36/46"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "42/45"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "45/45"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "41/45"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "38/45"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "42/48"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "21/45"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "33/47"
  },
  {
    "date": "24-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/50"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/48"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "35/48"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/50"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "38/45"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "23/47"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "31/48"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/45"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "34/48"
  },
  {
    "date": "24-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "39/45"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "33/45"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/45"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/47"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "44/48"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "21/45"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "43/48"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "31/47"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "36/48"
  },
  {
    "date": "25-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "27/49"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "32/45"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "23/48"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "39/48"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "43/50"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "23/47"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "26/46"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "23/47"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "40/45"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "43/49"
  },
  {
    "date": "25-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "37/49"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "29/50"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "28/45"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "40/49"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "44/47"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "26/45"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "20/46"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "41/46"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "32/46"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "37/49"
  },
  {
    "date": "25-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "32/47"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "35/47"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "27/48"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "33/46"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "39/46"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "44/45"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "43/49"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "28/49"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "31/47"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "32/46"
  },
  {
    "date": "25-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "27/46"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/48"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "29/47"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "43/48"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "40/50"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "39/50"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "45/48"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/46"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "33/49"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "24/46"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "39/46"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "36/49"
  },
  {
    "date": "25-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "37/46"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "38/50"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/46"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "36/48"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "40/48"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "30/49"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "39/49"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/45"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "27/45"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "39/46"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "35/49"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "44/45"
  },
  {
    "date": "25-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "37/45"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "29/47"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/49"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "37/49"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "39/47"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "39/50"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "41/49"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/45"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "38/45"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "25/47"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "38/47"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "37/49"
  },
  {
    "date": "25-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "35/49"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "20/49"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/49"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "33/45"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "26/45"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "25/47"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "36/50"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "23/49"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "22/48"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "20/49"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "38/46"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "41/48"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/47"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "44/47"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "29/50"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/45"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "38/48"
  },
  {
    "date": "25-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "27/48"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "31/49"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/47"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "41/50"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/47"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "40/48"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "30/46"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "42/49"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "24/45"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "43/46"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "38/50"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "45/50"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/49"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "37/50"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "36/48"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "39/45"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "41/50"
  },
  {
    "date": "25-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "29/45"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "40/45"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "37/50"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "43/47"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "43/47"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "37/49"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "35/47"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "24/48"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "28/49"
  },
  {
    "date": "25-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "45/49"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "36/50"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "33/48"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/47"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "23/50"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "22/46"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "26/46"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "27/47"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "43/47"
  },
  {
    "date": "25-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "20/45"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "33/47"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "33/46"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "37/47"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "43/50"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "34/45"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "40/49"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/45"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "38/45"
  },
  {
    "date": "26-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "23/48"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "29/50"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "45/50"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "30/48"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "45/48"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "26/48"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "35/50"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "24/45"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/47"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "23/47"
  },
  {
    "date": "26-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "25/46"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/48"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "42/49"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "29/45"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "27/50"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "38/48"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "33/48"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/46"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "22/45"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "42/47"
  },
  {
    "date": "26-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/50"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "45/46"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "45/45"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "41/48"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "43/46"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "36/50"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "31/50"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "26/46"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "32/49"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/49"
  },
  {
    "date": "26-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/49"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "22/45"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "32/45"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "28/50"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "20/48"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "44/45"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "32/46"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/46"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "26/46"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "27/47"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "38/47"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "27/45"
  },
  {
    "date": "26-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "25/45"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/45"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/49"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "28/46"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "30/45"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "30/48"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "37/47"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "43/47"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "31/46"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "22/45"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "25/46"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "26/45"
  },
  {
    "date": "26-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/50"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "39/49"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/49"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/50"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "27/47"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "31/48"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "41/49"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "20/46"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/49"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/50"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "34/47"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "26/50"
  },
  {
    "date": "26-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/45"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "36/46"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "26/45"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "27/50"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "35/47"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "25/47"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "23/46"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "39/50"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "31/48"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "23/47"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "43/49"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "32/49"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/48"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "36/46"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "33/45"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "33/45"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "44/49"
  },
  {
    "date": "26-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "26/46"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "41/50"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "30/47"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "44/48"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "35/47"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "21/49"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "38/45"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "41/45"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "36/49"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "28/47"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "25/50"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "41/47"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "42/46"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "45/46"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "37/45"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "40/47"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "45/47"
  },
  {
    "date": "26-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "36/48"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/48"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/46"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/48"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "25/49"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "31/49"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/47"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "41/49"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "32/49"
  },
  {
    "date": "26-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "28/45"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "21/46"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "44/50"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/49"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "40/49"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "33/46"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "28/46"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "41/47"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "24/46"
  },
  {
    "date": "26-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "32/47"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "37/50"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "42/47"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "35/48"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "38/47"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "28/48"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "39/47"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "36/47"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "21/49"
  },
  {
    "date": "28-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "33/47"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "25/46"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "38/47"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "21/48"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "24/48"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "37/45"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "37/49"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "23/50"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/47"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "34/47"
  },
  {
    "date": "28-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "33/50"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "38/47"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/45"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "27/49"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "28/49"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "38/47"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "45/50"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "21/48"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "22/46"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/46"
  },
  {
    "date": "28-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/47"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "23/47"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "42/47"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "22/47"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "28/50"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "38/48"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "27/49"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "20/47"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "34/50"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "33/48"
  },
  {
    "date": "28-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "45/45"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "36/50"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "24/49"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/46"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "22/45"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "29/45"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "30/49"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/49"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "24/49"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "35/49"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "41/47"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "37/49"
  },
  {
    "date": "28-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "44/48"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "32/46"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "27/46"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "37/49"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "38/47"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "34/47"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "28/45"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/47"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "26/47"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "32/46"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "29/45"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "39/48"
  },
  {
    "date": "28-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "24/46"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "42/46"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "27/50"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/45"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "37/45"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "37/50"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/50"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/45"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "34/48"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "27/50"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "29/46"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "26/47"
  },
  {
    "date": "28-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "38/45"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "26/49"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "41/45"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "32/46"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "22/46"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "28/50"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "41/48"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "20/49"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "44/45"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "27/46"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "20/47"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "24/48"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/49"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/47"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "23/50"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/50"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "31/50"
  },
  {
    "date": "28-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "35/50"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "35/49"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "22/47"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/49"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "21/45"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "31/46"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "35/46"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "23/46"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "31/47"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "24/47"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "25/49"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "24/50"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/49"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "26/45"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "22/46"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "44/50"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "26/47"
  },
  {
    "date": "28-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "21/47"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "43/50"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/50"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "32/47"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "41/46"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "36/48"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "26/49"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "31/49"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "25/47"
  },
  {
    "date": "28-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "22/46"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "33/45"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/48"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "40/46"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "28/48"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "31/47"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "39/48"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "30/47"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "38/46"
  },
  {
    "date": "28-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/48"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "21/45"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "33/45"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "23/50"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "23/48"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "27/46"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "22/49"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/48"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "45/47"
  },
  {
    "date": "29-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "40/48"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "32/50"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "29/45"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "27/50"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "29/47"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "39/45"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "36/46"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/45"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "36/49"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "24/49"
  },
  {
    "date": "29-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/50"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "29/49"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "41/45"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "29/48"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "27/46"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "30/49"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "35/46"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/46"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/47"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "41/46"
  },
  {
    "date": "29-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "39/45"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "42/50"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "42/49"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "38/47"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "32/50"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "39/50"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "30/47"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "22/46"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "24/46"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "39/49"
  },
  {
    "date": "29-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "23/47"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "24/49"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/49"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "20/48"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "34/48"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "30/47"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "42/47"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "25/50"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "42/46"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "33/46"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "40/47"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "30/49"
  },
  {
    "date": "29-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/45"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/46"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "33/45"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/49"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "33/46"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "42/46"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/48"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "31/49"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "43/45"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "36/50"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "29/48"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "23/48"
  },
  {
    "date": "29-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "29/46"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "37/48"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/49"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "42/45"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "42/50"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "23/48"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "31/48"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/50"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/47"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "44/45"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "22/46"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "44/49"
  },
  {
    "date": "29-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/45"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "37/49"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "21/47"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/50"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "34/46"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "43/47"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "32/47"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "45/47"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "35/45"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "41/45"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "38/48"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "42/47"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/45"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "38/48"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "20/46"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "28/49"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "36/48"
  },
  {
    "date": "29-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "45/49"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "29/50"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "28/48"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/48"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "34/50"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "21/48"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "32/49"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "31/48"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "41/47"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "36/50"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "31/49"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "43/46"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "31/48"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/50"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "36/46"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/46"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "21/45"
  },
  {
    "date": "29-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "39/49"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "21/46"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "20/50"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "25/46"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "40/48"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "39/49"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "41/48"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "24/46"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "26/45"
  },
  {
    "date": "29-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "31/50"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "40/48"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/47"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "26/49"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "34/47"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "32/50"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "30/50"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "21/49"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "23/49"
  },
  {
    "date": "29-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/50"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "23/49"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "43/47"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "24/48"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "25/50"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "27/48"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "21/47"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/45"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "27/45"
  },
  {
    "date": "30-04-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "20/48"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/48"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "26/46"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "21/50"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/46"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "24/48"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "39/47"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/49"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "31/45"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "21/47"
  },
  {
    "date": "30-04-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "39/49"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "28/47"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "42/48"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "23/50"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "44/46"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "36/50"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "44/49"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/45"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "33/50"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "40/45"
  },
  {
    "date": "30-04-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/46"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/45"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "39/50"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "38/48"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "27/48"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "38/46"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "45/45"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/48"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "30/49"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "29/46"
  },
  {
    "date": "30-04-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/46"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "23/49"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/49"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/50"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "35/45"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "21/46"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "38/50"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/45"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/49"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "27/48"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "36/48"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "36/48"
  },
  {
    "date": "30-04-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "27/46"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "45/50"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/50"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/46"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "31/50"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "31/45"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "30/45"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "35/48"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "36/47"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "36/46"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "36/48"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "28/50"
  },
  {
    "date": "30-04-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "37/50"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "44/48"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "33/48"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "21/50"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "31/47"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "39/48"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "38/47"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "38/47"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "41/49"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "38/47"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "25/50"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "41/50"
  },
  {
    "date": "30-04-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "41/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "39/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "23/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "24/49"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "22/49"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "28/45"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "25/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "38/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "38/46"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "20/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "38/49"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/50"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/46"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "24/45"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "22/46"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "35/48"
  },
  {
    "date": "30-04-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "31/47"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "32/48"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "42/48"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "35/49"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "30/48"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "35/50"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "29/49"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "30/49"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "33/50"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "42/49"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "27/45"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "25/49"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "43/50"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "39/46"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "20/46"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "29/46"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "26/45"
  },
  {
    "date": "30-04-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "24/50"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "33/45"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "26/46"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "38/50"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "41/48"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "33/46"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "45/48"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "39/46"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "36/48"
  },
  {
    "date": "30-04-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/45"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "42/46"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "23/49"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "45/48"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "36/49"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "44/45"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "34/47"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "28/48"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "39/45"
  },
  {
    "date": "30-04-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "38/50"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "38/50"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "21/50"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "35/50"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "23/50"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "31/50"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "35/45"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/49"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "40/49"
  },
  {
    "date": "01-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "22/46"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/50"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "40/48"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "36/48"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "36/48"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "22/46"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "24/45"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/47"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "32/47"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "32/46"
  },
  {
    "date": "01-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "33/50"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "40/49"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "24/45"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/46"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/46"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "24/49"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "45/45"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "24/49"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "44/49"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "28/48"
  },
  {
    "date": "01-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "36/48"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "41/45"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "36/47"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/50"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "42/48"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "24/49"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "32/50"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "23/50"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "34/45"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "42/47"
  },
  {
    "date": "01-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "26/50"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "33/50"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "20/45"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "31/49"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "44/49"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "34/45"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "34/48"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/47"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "30/49"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "32/49"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "24/45"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "37/50"
  },
  {
    "date": "01-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/46"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "44/47"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/48"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "42/48"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "44/45"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "27/46"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "41/45"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "25/48"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "23/48"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "33/47"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "34/49"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "41/45"
  },
  {
    "date": "01-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "37/46"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/50"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "27/47"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/49"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "31/45"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "28/47"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "25/48"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/46"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "40/45"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "37/49"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "26/49"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "28/48"
  },
  {
    "date": "01-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/49"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/45"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "39/47"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "24/48"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "34/46"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "41/45"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "25/49"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "25/47"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "42/48"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "22/49"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "44/49"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "28/47"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "31/46"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "22/46"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "22/46"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "38/46"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "42/49"
  },
  {
    "date": "01-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "38/50"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "37/46"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "41/47"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "30/50"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "20/49"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "44/46"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "28/47"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "29/46"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "40/48"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "31/47"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "35/48"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "32/50"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/49"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "41/45"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "42/46"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "30/50"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "32/45"
  },
  {
    "date": "01-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "30/49"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "20/46"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "38/45"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/49"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "45/46"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "43/49"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "42/45"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "38/48"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "27/48"
  },
  {
    "date": "01-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "44/48"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "33/48"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "43/49"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/46"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "20/49"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "39/45"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "35/46"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "27/47"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "40/47"
  },
  {
    "date": "01-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/49"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "38/45"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "36/49"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/50"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "35/45"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "22/45"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "21/49"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "34/48"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "45/50"
  },
  {
    "date": "02-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "43/50"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "27/48"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "43/49"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "39/46"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "21/49"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "45/46"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "35/48"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/48"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "29/48"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "20/47"
  },
  {
    "date": "02-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "44/49"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "20/48"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "27/46"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "44/47"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "44/48"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "42/45"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "21/49"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/46"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "41/46"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/48"
  },
  {
    "date": "02-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/45"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "26/46"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/49"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/50"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "37/45"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "25/47"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "21/48"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "22/48"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "38/50"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "34/45"
  },
  {
    "date": "02-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/45"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "26/47"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "35/48"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "36/48"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "23/50"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "22/50"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "24/50"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/47"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "33/48"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/50"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "41/45"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "37/48"
  },
  {
    "date": "02-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "28/46"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "28/47"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "22/46"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "44/46"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "39/48"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "20/50"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "36/48"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/49"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "41/46"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "30/46"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "31/45"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "43/48"
  },
  {
    "date": "02-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "32/45"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "45/46"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/49"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "39/50"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "21/50"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "41/48"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "24/47"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/49"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "39/47"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "23/45"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "30/49"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "28/49"
  },
  {
    "date": "02-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "31/48"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "37/49"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/49"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/47"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "31/48"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "28/50"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "33/47"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "41/45"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "37/47"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "31/45"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "29/49"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "35/45"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "36/50"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "36/50"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "26/49"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/49"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "43/48"
  },
  {
    "date": "02-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "35/45"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "45/48"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "39/47"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "26/45"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "31/47"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "28/45"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "41/48"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "44/49"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "40/48"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "39/46"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "20/45"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "41/49"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/46"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "23/46"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "27/45"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "43/50"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "39/46"
  },
  {
    "date": "02-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "24/47"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/45"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "26/49"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "33/50"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "41/45"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "42/46"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "40/47"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "41/46"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "21/47"
  },
  {
    "date": "02-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "27/46"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "32/50"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/45"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "40/47"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "37/49"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "21/50"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "33/50"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "36/49"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "29/45"
  },
  {
    "date": "02-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "40/48"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "42/48"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "32/47"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "41/45"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "31/47"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "42/48"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "37/50"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/47"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "43/48"
  },
  {
    "date": "03-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/47"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "23/49"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "22/45"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "28/49"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "34/47"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "27/49"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "23/50"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "25/46"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "40/47"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "25/46"
  },
  {
    "date": "03-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "42/47"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "20/48"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "24/50"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/50"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "34/49"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "41/49"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "35/48"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "32/49"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "30/47"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "43/48"
  },
  {
    "date": "03-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "39/47"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "35/50"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "35/45"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "20/46"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "33/50"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "28/48"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "34/49"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/47"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/50"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "23/50"
  },
  {
    "date": "03-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/45"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "22/46"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "40/47"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/47"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "44/50"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "22/50"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "29/50"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "44/48"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "31/49"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "31/48"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "36/48"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "23/50"
  },
  {
    "date": "03-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "43/47"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "30/50"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/46"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "25/49"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "44/47"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "36/46"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "20/48"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/46"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "22/45"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "22/47"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "37/50"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "43/45"
  },
  {
    "date": "03-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "43/49"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "40/48"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/48"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/48"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "29/45"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "30/45"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "37/47"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/50"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "42/49"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "21/50"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "30/49"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "44/50"
  },
  {
    "date": "03-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "44/45"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "39/49"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/47"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "35/50"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "43/50"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "38/47"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "42/49"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "25/48"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "24/47"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "44/49"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "43/47"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "42/48"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/48"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/45"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "45/46"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/49"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "45/50"
  },
  {
    "date": "03-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "45/50"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "24/50"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/48"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "38/49"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "36/49"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "36/48"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "35/45"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "21/48"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "34/50"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "39/49"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "43/49"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "20/50"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/45"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "37/47"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/45"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "44/46"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "33/50"
  },
  {
    "date": "03-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "32/50"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "43/48"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "22/49"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "27/45"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "32/46"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "40/45"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "32/46"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "29/45"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "29/45"
  },
  {
    "date": "03-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "30/49"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "38/45"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/47"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "21/45"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "44/49"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "20/50"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "45/46"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "41/45"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "41/50"
  },
  {
    "date": "03-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "29/50"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "23/45"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "42/50"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "42/50"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "35/47"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "30/45"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "35/46"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "30/50"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "20/48"
  },
  {
    "date": "05-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "45/48"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "37/50"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/50"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "38/49"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "38/45"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "40/46"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "24/50"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/49"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "32/46"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "22/49"
  },
  {
    "date": "05-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "44/45"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "22/50"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "26/47"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "27/45"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "38/49"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "22/45"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "37/46"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "44/49"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "37/47"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "36/47"
  },
  {
    "date": "05-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/45"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/47"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "32/46"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "39/46"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/49"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "38/48"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "41/49"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "26/50"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "21/46"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/46"
  },
  {
    "date": "05-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/49"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "27/48"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "21/45"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/47"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "43/49"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "25/47"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "41/49"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "26/46"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "33/46"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "40/46"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "21/50"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "30/48"
  },
  {
    "date": "05-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/47"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "22/47"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "40/48"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "41/46"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "21/48"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "35/45"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/46"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/46"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "31/46"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "23/45"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "44/46"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/50"
  },
  {
    "date": "05-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "33/50"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/49"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/47"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "27/48"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "29/46"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "20/50"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "23/48"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "27/48"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "23/46"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/46"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "27/49"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "44/48"
  },
  {
    "date": "05-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "25/46"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "24/45"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "44/45"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/50"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "37/48"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "29/45"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "35/45"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "38/46"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "38/45"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "33/49"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "22/46"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "45/47"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "28/50"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "20/49"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "25/49"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "24/48"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "26/50"
  },
  {
    "date": "05-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "26/45"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "32/48"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "21/45"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/47"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "24/47"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "26/48"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "28/47"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "25/48"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "24/47"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "22/49"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "33/48"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "20/50"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "29/46"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "34/46"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "35/49"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "28/50"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "34/48"
  },
  {
    "date": "05-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "32/47"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "23/49"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/49"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "21/49"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "40/50"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "28/49"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "30/45"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "41/46"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "44/50"
  },
  {
    "date": "05-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "20/48"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "34/46"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "25/45"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "27/49"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "32/48"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "32/45"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "27/49"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "26/47"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "23/48"
  },
  {
    "date": "05-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "44/47"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "27/45"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "29/48"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "26/46"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "20/47"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "37/46"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "22/46"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "44/49"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "31/45"
  },
  {
    "date": "06-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "28/48"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "32/49"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/48"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "24/45"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "20/46"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "34/50"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "21/48"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "21/48"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "28/50"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "33/46"
  },
  {
    "date": "06-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "37/47"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "33/50"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "45/45"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "34/50"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/47"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "38/50"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "28/48"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "35/49"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "41/48"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "29/49"
  },
  {
    "date": "06-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "42/50"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "20/50"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "26/49"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "24/49"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "44/45"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "39/45"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "29/46"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/47"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "44/49"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/47"
  },
  {
    "date": "06-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "33/45"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "20/49"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/49"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "42/45"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "32/48"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "24/45"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "27/49"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "34/46"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "43/49"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "21/46"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "31/50"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "25/46"
  },
  {
    "date": "06-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "24/46"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "42/48"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "41/48"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/48"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "20/45"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "25/46"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "21/49"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/46"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "31/49"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "37/47"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "31/45"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "39/48"
  },
  {
    "date": "06-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/48"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "28/46"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "33/45"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "33/45"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "29/48"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "29/49"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "24/48"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/49"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "44/49"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "41/46"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "26/50"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "35/49"
  },
  {
    "date": "06-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "43/46"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/50"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/50"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "43/47"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "41/48"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "40/47"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "26/45"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "25/48"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "41/50"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "40/48"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "27/49"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "31/48"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "20/46"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "43/48"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "34/49"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "27/45"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "26/50"
  },
  {
    "date": "06-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "40/47"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "40/50"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/47"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "30/48"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "33/50"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "41/45"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "39/50"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "34/50"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "22/47"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "20/50"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "35/50"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "28/49"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/49"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "29/47"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "37/46"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/49"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "42/48"
  },
  {
    "date": "06-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "40/49"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "37/46"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/48"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "26/47"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "31/46"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "35/48"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "44/46"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "39/48"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "42/45"
  },
  {
    "date": "06-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "39/48"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "22/45"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "29/45"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "27/48"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "37/48"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "35/48"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "30/48"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "30/47"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "21/47"
  },
  {
    "date": "06-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "30/47"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "28/49"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "37/47"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "28/47"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/49"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "40/50"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "27/45"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "30/49"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "36/48"
  },
  {
    "date": "07-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "35/49"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "28/50"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "25/45"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "38/45"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "21/49"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "32/50"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "45/46"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "37/48"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "27/48"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "37/48"
  },
  {
    "date": "07-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/49"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "32/46"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "37/48"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "35/48"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "42/46"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "38/49"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "25/47"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "31/48"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "44/47"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "29/47"
  },
  {
    "date": "07-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "30/47"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "22/48"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "42/50"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "44/49"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "38/47"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "40/50"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "38/49"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "25/48"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "42/48"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "36/49"
  },
  {
    "date": "07-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "45/48"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "45/47"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/47"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "40/46"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "42/49"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "37/46"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "30/48"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/50"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "42/48"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "22/49"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "42/50"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "26/45"
  },
  {
    "date": "07-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/47"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "20/50"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "28/49"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "37/48"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "22/50"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "45/45"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "34/46"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/46"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "25/50"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/48"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "33/45"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "39/47"
  },
  {
    "date": "07-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "36/50"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/45"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "43/48"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/46"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "32/47"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "29/47"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "27/48"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/48"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "28/48"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "36/46"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "24/48"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "27/47"
  },
  {
    "date": "07-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/49"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/47"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "36/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "28/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "33/45"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "23/49"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "31/48"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "24/49"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "31/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "29/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "28/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "38/45"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/48"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "31/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "38/46"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "26/45"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "41/50"
  },
  {
    "date": "07-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "43/45"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "33/47"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/49"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "37/47"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "30/49"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "35/50"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "43/47"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "37/46"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "32/45"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "32/50"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "42/46"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "43/50"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/47"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "41/47"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "20/45"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "42/49"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "36/50"
  },
  {
    "date": "07-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "42/47"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "25/48"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "41/49"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/45"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "35/49"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "26/46"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "43/48"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "32/48"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "45/47"
  },
  {
    "date": "07-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/45"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/48"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "24/49"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/46"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "39/48"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "29/49"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "41/47"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "41/50"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "32/45"
  },
  {
    "date": "07-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/45"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "45/50"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "25/48"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "24/49"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "37/48"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "30/50"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "42/49"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "36/47"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "35/49"
  },
  {
    "date": "08-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/48"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "21/46"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "23/50"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/46"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "45/47"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "40/48"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "24/45"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/47"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/45"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "41/47"
  },
  {
    "date": "08-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "27/49"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "37/47"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "36/47"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "35/46"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "28/50"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "25/46"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "23/48"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "31/50"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "23/48"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "39/48"
  },
  {
    "date": "08-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "44/48"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "33/50"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "33/46"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "25/46"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "23/47"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "37/47"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "20/48"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "41/50"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "20/48"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "40/46"
  },
  {
    "date": "08-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/47"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "24/46"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "45/50"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "24/48"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "32/47"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "43/47"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "45/45"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/50"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "44/47"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "27/48"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "25/49"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "44/48"
  },
  {
    "date": "08-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "31/48"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "27/46"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "23/46"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "41/45"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "44/47"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "27/46"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "27/49"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/48"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/49"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "39/47"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "25/48"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "34/49"
  },
  {
    "date": "08-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "44/45"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "38/45"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "23/50"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/48"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "25/47"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "27/48"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "35/45"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/47"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/50"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "41/49"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "28/46"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "29/45"
  },
  {
    "date": "08-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "32/50"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/45"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "33/50"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/47"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "33/45"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "38/46"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "27/49"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "27/48"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "29/45"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "43/49"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "41/45"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "32/47"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/49"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "21/49"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "42/45"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "36/47"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "44/50"
  },
  {
    "date": "08-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "44/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "45/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "22/45"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "28/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "45/47"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "43/48"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "37/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "28/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "41/47"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "24/47"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "33/49"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "26/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "26/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "23/47"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "40/48"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/46"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "42/47"
  },
  {
    "date": "08-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "43/45"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "37/50"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "35/48"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "21/50"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "23/46"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "27/45"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "22/46"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "36/46"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "43/48"
  },
  {
    "date": "08-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "26/45"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "26/46"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "38/46"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "22/48"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "32/50"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "45/49"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "29/46"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "22/45"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "43/47"
  },
  {
    "date": "08-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "21/46"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "22/45"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "33/45"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "30/46"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "43/50"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "27/48"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "35/48"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "25/47"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "24/47"
  },
  {
    "date": "09-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "20/49"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/48"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "30/47"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "23/46"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/46"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "22/50"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "24/49"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/50"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "32/48"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "34/50"
  },
  {
    "date": "09-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/48"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "28/50"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "40/46"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "44/49"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/45"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "45/47"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "25/45"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "45/50"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "29/49"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "35/45"
  },
  {
    "date": "09-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "42/46"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "41/48"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "31/49"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "31/49"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "40/47"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "26/46"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "36/50"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "45/46"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "39/48"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "42/45"
  },
  {
    "date": "09-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "24/46"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "23/46"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/49"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "38/47"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/48"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "42/50"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "21/49"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "20/50"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "24/45"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "45/46"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "29/45"
  },
  {
    "date": "09-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "37/50"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "26/48"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/47"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "41/49"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "27/45"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "38/50"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "22/50"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/45"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/49"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "21/46"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "29/47"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "34/50"
  },
  {
    "date": "09-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "45/50"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "33/50"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "29/45"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "43/45"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "23/46"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "20/47"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "20/48"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "42/50"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "44/47"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "40/50"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "37/50"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "20/47"
  },
  {
    "date": "09-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "23/47"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "42/47"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "33/48"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "33/46"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "23/45"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "22/47"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "25/48"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "43/46"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "41/48"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "30/49"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "24/49"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "22/45"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "31/45"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "36/46"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "40/46"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "35/46"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "22/46"
  },
  {
    "date": "09-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "42/46"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/50"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "45/45"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/46"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "42/45"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "25/48"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "21/50"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "35/48"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "33/50"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "39/50"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "42/50"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "33/47"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "28/47"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "31/45"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "31/46"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "25/48"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "43/49"
  },
  {
    "date": "09-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "43/48"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "27/45"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "25/48"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/47"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "34/48"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "42/45"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "40/49"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "36/50"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "38/48"
  },
  {
    "date": "09-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "33/50"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "31/46"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/45"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "41/50"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "34/49"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "39/45"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "20/46"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "26/48"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "40/45"
  },
  {
    "date": "09-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "23/50"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "24/46"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "26/49"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "38/50"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "26/48"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "37/49"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "22/45"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "39/45"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "36/45"
  },
  {
    "date": "10-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "25/47"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "23/48"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "33/49"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "37/45"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "35/45"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "29/48"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "38/49"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/45"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "41/47"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "43/45"
  },
  {
    "date": "10-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/49"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "30/49"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "28/47"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "36/45"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "44/47"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "22/48"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "45/50"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/48"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "22/46"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "26/46"
  },
  {
    "date": "10-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/50"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "29/45"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "41/49"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "40/46"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "26/47"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "32/48"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "41/47"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "23/48"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "23/49"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/45"
  },
  {
    "date": "10-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "26/47"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "37/49"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "42/48"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "30/45"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "42/47"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "44/47"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "45/48"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/46"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "37/50"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "27/47"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "35/48"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "33/46"
  },
  {
    "date": "10-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "24/50"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/49"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "27/49"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/46"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "40/48"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "28/46"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "27/46"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/47"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "29/48"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "45/47"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "23/50"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "26/47"
  },
  {
    "date": "10-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "26/46"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "23/49"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "23/46"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "45/50"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/48"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "22/47"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "22/49"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "34/49"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "41/48"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/49"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "22/50"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "43/47"
  },
  {
    "date": "10-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "25/47"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "34/46"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "24/46"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "41/50"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "30/46"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "42/46"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "26/48"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "29/46"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "37/50"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "29/48"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "32/47"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "44/48"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/49"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "25/46"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "22/45"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/50"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "21/50"
  },
  {
    "date": "10-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "28/50"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "44/48"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/48"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/47"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "33/48"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "30/45"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "30/50"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "24/46"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "21/48"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "41/46"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "20/50"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "20/48"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/47"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "38/49"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "40/47"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/49"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "21/48"
  },
  {
    "date": "10-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "38/47"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "38/48"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "36/47"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "29/45"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "22/48"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "32/46"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "27/47"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "41/47"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "26/49"
  },
  {
    "date": "10-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "21/48"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "23/49"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/45"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "42/47"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "24/49"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "23/47"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "43/50"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "26/48"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "22/50"
  },
  {
    "date": "10-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "44/47"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "21/49"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "21/49"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "45/48"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "39/46"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "36/45"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "21/48"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "43/45"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "27/50"
  },
  {
    "date": "12-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "26/48"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "45/48"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "42/47"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/49"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "25/47"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "22/48"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "20/50"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/50"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "45/46"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "44/50"
  },
  {
    "date": "12-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/45"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "30/45"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "39/50"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "25/50"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "33/48"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "41/48"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "42/49"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "38/49"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "38/50"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/49"
  },
  {
    "date": "12-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "42/47"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "21/49"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "33/45"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "21/47"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "28/50"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "37/45"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "30/47"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "45/48"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "32/47"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "28/46"
  },
  {
    "date": "12-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "33/48"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "26/46"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "29/49"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "41/46"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "28/45"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "21/49"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "20/50"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/50"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "29/47"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "34/45"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "21/48"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "44/45"
  },
  {
    "date": "12-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/47"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "24/50"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/47"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "23/48"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "20/48"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "28/49"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "29/46"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "28/46"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "29/48"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "34/47"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "33/49"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "35/48"
  },
  {
    "date": "12-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "30/48"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "45/45"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "30/46"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "21/49"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "44/47"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "33/45"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "38/46"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/45"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "35/48"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/49"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "42/49"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "23/45"
  },
  {
    "date": "12-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "33/45"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "32/50"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/45"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "44/47"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "25/48"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "38/49"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "33/45"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "27/50"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "43/50"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "36/49"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "24/45"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "38/47"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/45"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "26/47"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "40/47"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "28/46"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "40/47"
  },
  {
    "date": "12-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "22/50"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "31/46"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "33/47"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "25/50"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "22/49"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "39/47"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "22/46"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "22/49"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "25/45"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "31/48"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "43/49"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "44/48"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/48"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "31/48"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "45/50"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/49"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "45/47"
  },
  {
    "date": "12-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "40/46"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "35/45"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/46"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "30/49"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "45/50"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "21/47"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "33/48"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/45"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "29/45"
  },
  {
    "date": "12-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "33/48"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "27/47"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/49"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "36/49"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "30/47"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "28/46"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "40/50"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "34/50"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "44/45"
  },
  {
    "date": "12-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/49"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "23/50"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "44/47"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "33/47"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "25/48"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "44/50"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "34/46"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "30/46"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "33/45"
  },
  {
    "date": "13-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/50"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "36/46"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "31/45"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "27/47"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "42/45"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "36/45"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "34/46"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/49"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "36/50"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "22/48"
  },
  {
    "date": "13-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "42/50"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "29/50"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "24/49"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "29/47"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/50"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "25/48"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "28/47"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "29/47"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "42/46"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "25/47"
  },
  {
    "date": "13-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/45"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "21/49"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "21/49"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "31/45"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "35/49"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "43/46"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "21/45"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/46"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/45"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "22/47"
  },
  {
    "date": "13-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "42/47"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "40/50"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "44/45"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/48"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "29/45"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "23/48"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "40/46"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/48"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "34/46"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "37/46"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "38/50"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "40/50"
  },
  {
    "date": "13-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "20/45"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "43/48"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "23/49"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/46"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "33/48"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "24/45"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "34/46"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/46"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "35/46"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "34/45"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "33/49"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "40/45"
  },
  {
    "date": "13-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "23/46"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/49"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "30/47"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/46"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "34/48"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "28/45"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "37/46"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "25/48"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/47"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "23/45"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "27/49"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "24/49"
  },
  {
    "date": "13-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/45"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "43/49"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "20/45"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/49"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "23/45"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "22/46"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "37/46"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "23/48"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "33/46"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "39/48"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "40/47"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "41/47"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/49"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/47"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "28/50"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "27/48"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "27/48"
  },
  {
    "date": "13-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "41/48"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "39/48"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "45/48"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/48"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "43/47"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "22/46"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/46"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "21/50"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "42/50"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "43/47"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "31/46"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "34/46"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/49"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "34/45"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "24/48"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "37/46"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "34/46"
  },
  {
    "date": "13-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/50"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "28/47"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/45"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/48"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "33/47"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "31/49"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "25/50"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "34/47"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "27/45"
  },
  {
    "date": "13-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "37/45"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "21/45"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "20/50"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/48"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "27/45"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "35/46"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "38/47"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "21/48"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "38/46"
  },
  {
    "date": "13-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "38/49"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "29/49"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "39/46"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "40/46"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "37/50"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "27/49"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "28/50"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "20/49"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "40/47"
  },
  {
    "date": "14-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/48"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "28/47"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "35/48"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/48"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "45/46"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "29/47"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "41/45"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "23/48"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "21/49"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "42/47"
  },
  {
    "date": "14-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "34/49"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "28/47"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "21/49"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "28/46"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "38/48"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "45/46"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "41/48"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "35/49"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "39/48"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "43/48"
  },
  {
    "date": "14-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/46"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "45/45"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "29/45"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "35/50"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "31/45"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "38/45"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "22/48"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "31/46"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "23/45"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "39/48"
  },
  {
    "date": "14-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/48"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/49"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/45"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/50"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "23/45"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "41/47"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "38/49"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "35/45"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "37/48"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "20/47"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/45"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "33/49"
  },
  {
    "date": "14-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "20/47"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "37/47"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/46"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "42/46"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "32/49"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "36/49"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "25/50"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/45"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "37/50"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "43/50"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "21/48"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "28/45"
  },
  {
    "date": "14-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "44/50"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "26/45"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "35/46"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/46"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "39/50"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "40/46"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "41/46"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/47"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "32/50"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "43/46"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "39/48"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "20/48"
  },
  {
    "date": "14-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "35/47"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "20/45"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/49"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/47"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "25/48"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "30/50"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "31/46"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "44/49"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "35/49"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "38/47"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "39/46"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "20/48"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/50"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "33/46"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "33/48"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "36/48"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "43/47"
  },
  {
    "date": "14-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "33/48"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "25/49"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/50"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "28/47"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "38/47"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "29/49"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "30/46"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "26/48"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "35/49"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "34/46"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "41/48"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "43/48"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/45"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "45/45"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "22/50"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "35/48"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "27/48"
  },
  {
    "date": "14-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "36/48"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "30/50"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "37/49"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "40/47"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "40/45"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "24/48"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "30/49"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "45/49"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "34/49"
  },
  {
    "date": "14-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "22/46"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "37/45"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/49"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "24/47"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "39/45"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "35/50"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/45"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "33/50"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "20/45"
  },
  {
    "date": "14-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "43/47"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "37/48"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "41/45"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "30/46"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "35/48"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "29/48"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "32/48"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/48"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/47"
  },
  {
    "date": "15-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "31/45"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "29/49"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "23/47"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "43/50"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "36/46"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "22/50"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "25/50"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/47"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "31/47"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "24/45"
  },
  {
    "date": "15-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "37/50"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "37/47"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "30/45"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "30/49"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "23/45"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "20/45"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "40/45"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/48"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "36/45"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "33/46"
  },
  {
    "date": "15-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "30/48"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "29/46"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "34/46"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/48"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "36/46"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "27/49"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "32/49"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/47"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "42/46"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "41/46"
  },
  {
    "date": "15-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "45/49"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/45"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/47"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/47"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "34/48"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "24/46"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "41/45"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "40/48"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "31/47"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "26/48"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "30/45"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "45/50"
  },
  {
    "date": "15-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "41/49"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "41/49"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/47"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/50"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "45/45"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "24/50"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "35/48"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "40/48"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "26/48"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "26/46"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "34/47"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "30/49"
  },
  {
    "date": "15-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "45/45"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "22/47"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/47"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/49"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "23/48"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "20/50"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "28/49"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/48"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "42/45"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "34/46"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "20/50"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "42/46"
  },
  {
    "date": "15-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "22/50"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "43/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "36/46"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "20/46"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "30/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "24/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "23/46"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "31/49"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "37/50"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "24/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "35/49"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/46"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "41/50"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "33/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "23/47"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "43/48"
  },
  {
    "date": "15-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "42/46"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "26/50"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/49"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "41/47"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "37/47"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "44/50"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "37/49"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "43/47"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "27/49"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "34/48"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "41/49"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "35/45"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "26/45"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/50"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "38/49"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/50"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "34/50"
  },
  {
    "date": "15-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "27/50"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "20/45"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/45"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "34/47"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "32/47"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "34/45"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "42/49"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "41/46"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "40/47"
  },
  {
    "date": "15-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "20/45"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "22/47"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "29/50"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/46"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "21/46"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "27/45"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "24/48"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "20/45"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "28/46"
  },
  {
    "date": "15-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "25/50"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "45/48"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "42/48"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "22/46"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "23/45"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "21/50"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "26/47"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "26/45"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "33/46"
  },
  {
    "date": "16-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "37/47"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "22/49"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "20/47"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "38/49"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "29/45"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "27/48"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "33/49"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "28/50"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "31/49"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "38/49"
  },
  {
    "date": "16-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "31/49"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "27/49"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "33/49"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "28/50"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/50"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "43/47"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "44/48"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "33/47"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "36/49"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "26/48"
  },
  {
    "date": "16-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "44/45"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "26/50"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "32/45"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "30/49"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "38/47"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "44/49"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "36/45"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "35/49"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "26/48"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "37/46"
  },
  {
    "date": "16-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "31/49"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "39/49"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/47"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/48"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "38/49"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "45/49"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "27/47"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/47"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/47"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "31/50"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "26/45"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "20/48"
  },
  {
    "date": "16-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "33/45"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/47"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "42/47"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "35/47"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "36/46"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "33/48"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "20/47"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "39/48"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "39/47"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "20/45"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "26/48"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "24/49"
  },
  {
    "date": "16-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "23/50"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "24/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "28/49"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "24/45"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "24/48"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "20/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "20/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "34/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "42/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "36/48"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "32/46"
  },
  {
    "date": "16-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "32/45"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "36/50"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "31/49"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "34/49"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "37/45"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "29/45"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "29/48"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "45/46"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "28/49"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "44/45"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "45/48"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "36/49"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "39/45"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "25/50"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "41/45"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "44/50"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "42/48"
  },
  {
    "date": "16-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "37/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "36/49"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "37/47"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "38/50"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "31/50"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "42/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "21/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "28/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "31/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "33/46"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "20/47"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "40/46"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "36/46"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "37/46"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/48"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "37/45"
  },
  {
    "date": "16-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "42/48"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "38/45"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "20/48"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "45/48"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "38/50"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "45/50"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "22/49"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "43/50"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "20/47"
  },
  {
    "date": "16-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/50"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "43/50"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/45"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "43/50"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "22/45"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "32/45"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "25/49"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "24/46"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "40/45"
  },
  {
    "date": "16-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/46"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "32/49"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "20/48"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "35/47"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "33/48"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "26/46"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "25/46"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "41/46"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "37/47"
  },
  {
    "date": "17-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "39/49"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "23/49"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "43/47"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "26/45"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "34/45"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "36/46"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "33/49"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "33/46"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "30/50"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "25/48"
  },
  {
    "date": "17-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "31/47"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "33/48"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "30/49"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "23/47"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "30/48"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "22/49"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "43/48"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "44/46"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "41/50"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "30/49"
  },
  {
    "date": "17-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "35/50"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "41/46"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "29/46"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "40/49"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "22/45"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "39/50"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "22/47"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/50"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "33/50"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "39/50"
  },
  {
    "date": "17-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/46"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "32/50"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "28/46"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/49"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "33/50"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "33/46"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "31/48"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "42/49"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "39/46"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "21/50"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "40/49"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "21/48"
  },
  {
    "date": "17-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/48"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "29/50"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/49"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "28/48"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "31/50"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "24/48"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "35/45"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "34/50"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/48"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/50"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "32/45"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "26/49"
  },
  {
    "date": "17-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/50"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "25/49"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/50"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "32/49"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "42/48"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "31/49"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "37/49"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "33/46"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "27/45"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/49"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "28/45"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "43/45"
  },
  {
    "date": "17-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "28/45"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "33/50"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "28/45"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "25/47"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "44/46"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "40/48"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "35/50"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "26/50"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "39/46"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "37/46"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "27/50"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "32/49"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "34/48"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "40/48"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "36/48"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "25/49"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "31/45"
  },
  {
    "date": "17-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "41/49"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "33/46"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "38/45"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "35/46"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "42/47"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "23/45"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "40/49"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "22/47"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "36/49"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "44/48"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "45/48"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "28/48"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "27/46"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "32/46"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "23/46"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "43/47"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "45/45"
  },
  {
    "date": "17-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/46"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/49"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "32/45"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "38/45"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "35/49"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "40/49"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "40/47"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "21/47"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "40/49"
  },
  {
    "date": "17-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/45"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/45"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/50"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "27/46"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "45/50"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "35/48"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "25/50"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "21/50"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "39/48"
  },
  {
    "date": "17-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "31/47"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "41/50"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "31/48"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "36/49"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "30/49"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "22/47"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "40/49"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "39/48"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/50"
  },
  {
    "date": "19-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/50"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "34/49"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "44/45"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/48"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "36/49"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "40/50"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "28/48"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/47"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "35/46"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "24/48"
  },
  {
    "date": "19-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "38/49"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "37/45"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "39/49"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "39/47"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "23/48"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "44/49"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "30/48"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "33/45"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "27/48"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "34/45"
  },
  {
    "date": "19-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "41/49"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "28/50"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "33/46"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "22/50"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "26/48"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "42/45"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "44/50"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "30/48"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "43/45"
  },
  {
    "date": "19-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "21/50"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "22/50"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "40/48"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "29/46"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/49"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "28/50"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "26/48"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "44/47"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/47"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "38/50"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "32/50"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "37/45"
  },
  {
    "date": "19-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/45"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "25/48"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "27/46"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "41/49"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "29/46"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "26/48"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "21/45"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "39/49"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "25/47"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "23/47"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "37/49"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "33/50"
  },
  {
    "date": "19-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "42/49"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "43/50"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "27/48"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "43/46"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "29/48"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "28/50"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "20/47"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "25/46"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "31/47"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "26/48"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "27/46"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "28/50"
  },
  {
    "date": "19-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "31/49"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "42/47"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "22/48"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "30/48"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "34/45"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "35/48"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "39/49"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "24/45"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "36/46"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "41/50"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "43/45"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "33/45"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/47"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "40/45"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "42/49"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "20/49"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "29/49"
  },
  {
    "date": "19-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/49"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/46"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "23/47"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "37/46"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "23/45"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "40/50"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "33/49"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "27/45"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "44/48"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "31/48"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "41/46"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "29/45"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "42/49"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "35/47"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "35/50"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "45/49"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "43/45"
  },
  {
    "date": "19-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "40/48"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "21/45"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "40/45"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "20/47"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "44/46"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "31/45"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "32/47"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "36/45"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "40/47"
  },
  {
    "date": "19-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "24/50"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "38/50"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/46"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/47"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "37/46"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "39/46"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "30/45"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "21/45"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "31/45"
  },
  {
    "date": "19-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "24/46"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "21/45"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "40/48"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/50"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "44/45"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "38/46"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "30/48"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "25/47"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "28/46"
  },
  {
    "date": "20-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "35/48"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "26/48"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "40/47"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "44/46"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "37/49"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "30/48"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "42/45"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/47"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "29/48"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "37/45"
  },
  {
    "date": "20-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "35/46"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "43/47"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "38/46"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/46"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "33/45"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "30/46"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "22/49"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/48"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "33/47"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "20/45"
  },
  {
    "date": "20-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "44/48"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "26/46"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "27/48"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "39/48"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "44/46"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "22/48"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "45/50"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "44/50"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "29/46"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "34/45"
  },
  {
    "date": "20-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "20/49"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "36/50"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "39/46"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "26/48"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "38/48"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "27/48"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "39/46"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/45"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "24/45"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "43/50"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "35/45"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "33/48"
  },
  {
    "date": "20-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "27/50"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "23/49"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "28/45"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "35/45"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "38/45"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "41/45"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "20/47"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/49"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "21/48"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/47"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "44/48"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "39/47"
  },
  {
    "date": "20-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "42/50"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "20/45"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "30/49"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "45/48"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "36/47"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "24/48"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "29/45"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/50"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "29/48"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "45/48"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "24/45"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "33/45"
  },
  {
    "date": "20-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "41/46"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "45/45"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "23/48"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "40/46"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "33/49"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "42/49"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "32/46"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "34/45"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "26/47"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "29/48"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "37/50"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "32/50"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/47"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "26/48"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "21/47"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/45"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "22/48"
  },
  {
    "date": "20-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/50"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/48"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/45"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "29/45"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "41/48"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "42/50"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "24/47"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "27/49"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "42/46"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "31/45"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "34/50"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "42/49"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "44/48"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "42/45"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "39/46"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "39/45"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/46"
  },
  {
    "date": "20-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "38/45"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "39/46"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "26/49"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/48"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/49"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "35/48"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "38/45"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "45/50"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "36/48"
  },
  {
    "date": "20-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "21/49"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "35/48"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/47"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/50"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "20/47"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "24/48"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "45/48"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "24/48"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "40/45"
  },
  {
    "date": "20-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/50"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "42/47"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "20/49"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "38/48"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "29/46"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "39/49"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "35/50"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/48"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "33/47"
  },
  {
    "date": "21-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "37/50"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "44/49"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "30/50"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "37/45"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "29/48"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "41/49"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "31/46"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/47"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "39/47"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "30/49"
  },
  {
    "date": "21-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/47"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "38/47"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "20/50"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "43/48"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "28/45"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "35/45"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "41/50"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "26/50"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "20/48"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "44/48"
  },
  {
    "date": "21-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "23/47"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "39/47"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "44/45"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "44/49"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "35/46"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "29/47"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "35/45"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/45"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "22/50"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "34/48"
  },
  {
    "date": "21-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "31/47"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "24/46"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/46"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/49"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "30/46"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "35/46"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "39/46"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "23/50"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "23/50"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "45/49"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "39/47"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "36/45"
  },
  {
    "date": "21-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "42/49"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "28/50"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/49"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/50"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "42/49"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "41/46"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "30/46"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/45"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "38/48"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/50"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "43/48"
  },
  {
    "date": "21-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/47"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "20/47"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/45"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/50"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/47"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "23/46"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "22/45"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "39/49"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "42/49"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "23/46"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "24/46"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "39/50"
  },
  {
    "date": "21-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "30/49"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "29/50"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "26/45"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "45/50"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "31/46"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "39/50"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "40/45"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "39/49"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "38/47"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "24/49"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "36/47"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "36/50"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "43/49"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "31/47"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "38/46"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "23/47"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "32/47"
  },
  {
    "date": "21-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "22/48"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/47"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/47"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "34/45"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "32/45"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "29/50"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "24/45"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "30/50"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "29/46"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "36/46"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "21/49"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "35/46"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "30/48"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "42/48"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "36/45"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "24/49"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "43/49"
  },
  {
    "date": "21-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "35/45"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "40/46"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "24/49"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/46"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "21/49"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "21/48"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "44/49"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "42/45"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "32/47"
  },
  {
    "date": "21-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/48"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/47"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "37/45"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "31/49"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "36/47"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "32/47"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "29/49"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "42/45"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "30/47"
  },
  {
    "date": "21-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/47"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "40/48"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "29/48"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "35/45"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "31/49"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "30/45"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "21/47"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "26/49"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "33/46"
  },
  {
    "date": "22-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "36/49"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "31/46"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "38/49"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "45/47"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "44/47"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "30/49"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "29/45"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/45"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "23/48"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "20/48"
  },
  {
    "date": "22-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "26/46"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "28/47"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "44/45"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "29/45"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "29/49"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "34/47"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "44/49"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "30/46"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "25/47"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "35/45"
  },
  {
    "date": "22-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/50"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "35/47"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "42/50"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "29/45"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/45"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "25/45"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "25/48"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/48"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "42/50"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "42/48"
  },
  {
    "date": "22-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/49"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "30/45"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "44/49"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/45"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "25/50"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "37/48"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "31/47"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/49"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/46"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "33/46"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "40/47"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "33/50"
  },
  {
    "date": "22-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "37/47"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/47"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "28/45"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "20/50"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/45"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "36/45"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "40/49"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "37/48"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "26/45"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "22/50"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "39/47"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "20/48"
  },
  {
    "date": "22-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/50"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "27/45"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "39/50"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "43/45"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "27/48"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "29/49"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "22/47"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "20/49"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/46"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "20/50"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "27/49"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "34/49"
  },
  {
    "date": "22-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "41/48"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "33/48"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "22/46"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "33/50"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "21/48"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "35/50"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "35/46"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "35/50"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "37/50"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "34/46"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "31/47"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "33/47"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "32/46"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "27/50"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "43/47"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "21/47"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "25/49"
  },
  {
    "date": "22-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "40/46"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "26/49"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "21/48"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/45"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "35/47"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "24/47"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "44/48"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "20/50"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "37/46"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "36/47"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "32/47"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "37/50"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/48"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/47"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "22/46"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/45"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "42/48"
  },
  {
    "date": "22-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/47"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "22/45"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "24/46"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "45/48"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "43/48"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "45/45"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "41/45"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "40/47"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "40/50"
  },
  {
    "date": "22-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "24/49"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "35/49"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "22/48"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/45"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "45/47"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "36/48"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "21/49"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "28/46"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "38/50"
  },
  {
    "date": "22-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/46"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "21/49"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "32/46"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "33/48"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "32/45"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "35/45"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "43/45"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "28/45"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "31/46"
  },
  {
    "date": "23-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "21/50"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "31/46"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "40/48"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "21/45"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "33/50"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "28/47"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "40/50"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "44/45"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "24/47"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "38/47"
  },
  {
    "date": "23-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "34/50"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "31/48"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "41/47"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "42/49"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "29/48"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "32/46"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "32/45"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "21/48"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "28/48"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "37/48"
  },
  {
    "date": "23-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "41/45"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "27/45"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "41/47"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "31/47"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "23/50"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "40/45"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "36/45"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/46"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "33/50"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "23/50"
  },
  {
    "date": "23-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "41/45"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "23/50"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "40/47"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "38/47"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "42/47"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "26/47"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "42/45"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "25/49"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "44/48"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "20/49"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "23/47"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "24/47"
  },
  {
    "date": "23-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "30/46"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "28/48"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "42/49"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "44/50"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "24/47"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "45/50"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "37/48"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/46"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "30/46"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "21/46"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "35/46"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "35/50"
  },
  {
    "date": "23-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "43/46"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "37/45"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "25/49"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "39/45"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "24/46"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "24/49"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "42/46"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/49"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "31/48"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "41/45"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "35/47"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "38/45"
  },
  {
    "date": "23-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "44/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "22/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "20/46"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "35/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "39/48"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "43/45"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "25/48"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "32/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "31/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "22/45"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "20/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "45/45"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "38/47"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "32/49"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "35/50"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "28/48"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "44/46"
  },
  {
    "date": "23-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "24/47"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "22/47"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/48"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/49"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "36/50"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "30/48"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "35/49"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "25/49"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "35/48"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "45/50"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "29/49"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "44/46"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "37/47"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/48"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "28/50"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "27/48"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "38/46"
  },
  {
    "date": "23-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "34/50"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "30/47"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "26/49"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "44/50"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "37/46"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "36/47"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "35/47"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "26/45"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "24/45"
  },
  {
    "date": "23-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "25/45"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "40/49"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "29/50"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/46"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "35/49"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "42/49"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "26/49"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "41/50"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "30/46"
  },
  {
    "date": "23-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "43/45"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "26/48"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/50"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "28/47"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "37/49"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "26/46"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "45/48"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "43/46"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "44/48"
  },
  {
    "date": "24-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "31/50"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "26/49"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "24/48"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "31/49"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "23/47"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "24/46"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "31/47"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/50"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/45"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "26/47"
  },
  {
    "date": "24-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/46"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "39/48"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "40/49"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "40/45"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "37/46"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "43/47"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "32/47"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/47"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "21/46"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/45"
  },
  {
    "date": "24-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/49"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "24/50"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "42/47"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "31/49"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "36/46"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "20/49"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "39/49"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/49"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "40/48"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "33/49"
  },
  {
    "date": "24-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "43/45"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "28/49"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "30/48"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "29/47"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "42/46"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "28/45"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "35/46"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "25/50"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "41/46"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "45/48"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "44/46"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "39/47"
  },
  {
    "date": "24-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "39/45"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "44/50"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/48"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "38/46"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "24/50"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "41/48"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "20/45"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "40/48"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "30/45"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "34/48"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "36/45"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/45"
  },
  {
    "date": "24-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "28/47"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "26/50"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "36/48"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "21/50"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/48"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "30/48"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "23/46"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "21/45"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "34/47"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "30/48"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "31/50"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "32/47"
  },
  {
    "date": "24-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "44/45"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "24/50"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "35/45"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/47"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "22/49"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "23/50"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "25/49"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "37/50"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "25/49"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "24/49"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "34/45"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "23/49"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "44/48"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "23/50"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "21/49"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "42/47"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "33/46"
  },
  {
    "date": "24-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/47"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "21/49"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/46"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "33/49"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "27/46"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "40/50"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "43/46"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "45/45"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "43/46"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "28/50"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "24/46"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "27/48"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/47"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "25/47"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "20/45"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "35/49"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "35/46"
  },
  {
    "date": "24-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "28/50"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "26/50"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/48"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "40/47"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "23/45"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "24/47"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "37/47"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "38/46"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "29/47"
  },
  {
    "date": "24-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "20/45"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/47"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "31/45"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "33/48"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "41/47"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "34/45"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "40/50"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "25/49"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "39/50"
  },
  {
    "date": "24-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "28/47"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "30/46"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "30/47"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "37/48"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "36/49"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "27/46"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "28/47"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "40/46"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "20/50"
  },
  {
    "date": "26-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "25/46"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "34/47"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "22/47"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "38/48"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "35/45"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "23/48"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "41/49"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "38/48"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "25/50"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "24/45"
  },
  {
    "date": "26-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "39/45"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "37/47"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "44/48"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "21/47"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "34/46"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "33/49"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "44/48"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/50"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "30/47"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "33/47"
  },
  {
    "date": "26-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "25/49"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "33/47"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "27/47"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "36/46"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "31/49"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "42/45"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "32/45"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "20/47"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "40/45"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "22/50"
  },
  {
    "date": "26-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "20/50"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "26/47"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "34/46"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "39/46"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "37/46"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "38/45"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "39/49"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "24/47"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "23/49"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "24/49"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "43/50"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "26/47"
  },
  {
    "date": "26-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "32/45"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "44/46"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "23/48"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "43/46"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "36/48"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "45/49"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "25/45"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "39/48"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "25/47"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "40/46"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "39/50"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "36/45"
  },
  {
    "date": "26-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "45/47"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/45"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "30/47"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "26/45"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "33/48"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "39/47"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "26/46"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/46"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "24/46"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "25/46"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "41/46"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "35/47"
  },
  {
    "date": "26-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/47"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "38/50"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/45"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "42/48"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/49"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "34/49"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "42/49"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "36/48"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "37/48"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "22/50"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "27/49"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "38/50"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "44/47"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/45"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "44/49"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "39/46"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "27/46"
  },
  {
    "date": "26-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "29/46"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "24/47"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/46"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "27/48"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "39/50"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "31/45"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "40/48"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "27/47"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "26/46"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "24/49"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "40/50"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "42/48"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "22/46"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/50"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "21/47"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "42/47"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "39/46"
  },
  {
    "date": "26-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "21/45"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "31/46"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "22/48"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/46"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "35/47"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "28/47"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "27/47"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "38/48"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "23/49"
  },
  {
    "date": "26-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "28/49"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "31/49"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "43/48"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/50"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "39/45"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "36/49"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "38/49"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "20/45"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "45/47"
  },
  {
    "date": "26-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "23/45"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "38/49"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "33/47"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "39/49"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/45"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "39/47"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "37/45"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/46"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "36/47"
  },
  {
    "date": "27-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/47"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "36/46"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "41/47"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "34/48"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "45/45"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "37/49"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "40/47"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/50"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "43/46"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "26/47"
  },
  {
    "date": "27-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "23/46"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "28/50"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "26/49"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/50"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "25/48"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "23/49"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "44/49"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/45"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/49"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "37/49"
  },
  {
    "date": "27-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/46"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "22/50"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "40/48"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "41/47"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "45/45"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "35/50"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "25/45"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "37/45"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "40/46"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/45"
  },
  {
    "date": "27-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/46"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "45/47"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "24/47"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "21/49"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "24/49"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "25/48"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "37/48"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "38/50"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "38/46"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "39/46"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "27/45"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "25/46"
  },
  {
    "date": "27-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/48"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "43/50"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "30/49"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "37/46"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "43/50"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "20/47"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "25/45"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "32/48"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "37/45"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "28/45"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "33/50"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "44/48"
  },
  {
    "date": "27-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "37/50"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "38/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "27/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "23/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "27/50"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "35/45"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "33/48"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "29/45"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "24/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "27/49"
  },
  {
    "date": "27-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/48"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "28/50"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/46"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "25/50"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "31/45"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "24/48"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "37/45"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "25/45"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "31/46"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "34/47"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "39/47"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "44/46"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/48"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "41/48"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "33/49"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "22/50"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "27/50"
  },
  {
    "date": "27-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/50"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "21/45"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "39/50"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "26/50"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "35/49"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "30/49"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "41/45"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "35/48"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "31/45"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "44/50"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "30/46"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "33/45"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/49"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "43/47"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "34/50"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "45/49"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "28/49"
  },
  {
    "date": "27-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "31/47"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "23/48"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "45/46"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/47"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "32/50"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "31/50"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "22/48"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "32/46"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "20/46"
  },
  {
    "date": "27-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "41/46"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "45/49"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "36/45"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/47"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "25/50"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "30/47"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "30/47"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "37/45"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "27/45"
  },
  {
    "date": "27-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "27/48"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "34/48"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "37/50"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "38/47"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "42/48"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "22/49"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "23/45"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/50"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "30/50"
  },
  {
    "date": "28-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "42/50"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "44/50"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "31/50"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "25/48"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "36/50"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "35/48"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "43/50"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "20/48"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "39/50"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "22/47"
  },
  {
    "date": "28-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "29/47"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "45/48"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "24/49"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "45/49"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "32/47"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "31/50"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "40/45"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "43/46"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/47"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "22/48"
  },
  {
    "date": "28-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "31/47"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/50"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "38/48"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "45/49"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "26/49"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "36/46"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "31/46"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/46"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "34/49"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/46"
  },
  {
    "date": "28-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "42/49"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "43/48"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "32/49"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "37/50"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Magnetism",
    "countStudents": "31/45"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/45"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "27/49"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "30/48"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "29/47"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "23/47"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "42/45"
  },
  {
    "date": "28-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "30/47"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "24/48"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "32/50"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "25/48"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "22/46"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "26/46"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "39/45"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "20/47"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "24/50"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "30/50"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "32/48"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "21/47"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "35/45"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "40/50"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "27/49"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "29/49"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "25/50"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "41/50"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "26/45"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/45"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "39/47"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "28/49"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "28/47"
  },
  {
    "date": "28-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "33/50"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "28/49"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "34/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "22/46"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "29/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "25/49"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "45/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "28/47"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "30/47"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "33/47"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "34/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "29/48"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "38/47"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "28/46"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "30/47"
  },
  {
    "date": "28-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/45"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "24/47"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "22/49"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "37/46"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "22/46"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "44/48"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "44/47"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "38/50"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "40/47"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "27/47"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "45/46"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "34/46"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "23/50"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "39/45"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "39/48"
  },
  {
    "date": "28-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/49"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "38/49"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "36/48"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/45"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "36/48"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "34/49"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "44/50"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "28/45"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "28/47"
  },
  {
    "date": "28-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "23/49"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "27/46"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/48"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "33/45"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "37/46"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "30/50"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "30/49"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "36/48"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "37/48"
  },
  {
    "date": "28-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "32/48"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "29/50"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "30/46"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "25/50"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "35/47"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "44/45"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "38/47"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/47"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "29/50"
  },
  {
    "date": "29-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "27/46"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "27/50"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/49"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "36/48"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "42/45"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "24/48"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "31/47"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/50"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "24/49"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "43/49"
  },
  {
    "date": "29-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "26/45"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "42/47"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "20/49"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "25/49"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "20/49"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "33/50"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "27/47"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/49"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "24/48"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "45/48"
  },
  {
    "date": "29-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "37/50"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "26/47"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "22/48"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "28/50"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "25/49"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "28/50"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "41/45"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/45"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "33/46"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "39/48"
  },
  {
    "date": "29-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "45/45"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "22/49"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "36/48"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/45"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "20/50"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "33/48"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "32/48"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "36/50"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "34/47"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "25/48"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "38/48"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "36/45"
  },
  {
    "date": "29-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "30/49"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "33/48"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "25/48"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "41/47"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "30/50"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "30/46"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "30/49"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "35/49"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "23/49"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "32/49"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "20/50"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "38/47"
  },
  {
    "date": "29-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "42/46"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "37/46"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "36/46"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "44/46"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/45"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "23/50"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "33/46"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "23/45"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "20/50"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "42/45"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "21/50"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "23/47"
  },
  {
    "date": "29-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/50"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/49"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/49"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/45"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "22/50"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "43/47"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "22/45"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "28/49"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "28/45"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "37/47"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "34/48"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "27/50"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "43/49"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/49"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "31/47"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/48"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "34/49"
  },
  {
    "date": "29-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "23/45"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "26/45"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/48"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "22/48"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "22/45"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "28/47"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "29/47"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "33/50"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "34/48"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "27/49"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "24/49"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "44/49"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "38/48"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "21/50"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "34/48"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/45"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "27/50"
  },
  {
    "date": "29-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "33/47"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "29/49"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/50"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "20/50"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "22/48"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Differentiation",
    "countStudents": "20/46"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "35/48"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "20/50"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "22/46"
  },
  {
    "date": "29-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "30/47"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "23/47"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "33/47"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "37/50"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "23/47"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "39/48"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "30/45"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "43/48"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "26/48"
  },
  {
    "date": "29-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "22/45"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "31/49"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "37/48"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/47"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "43/48"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "21/48"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "24/50"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/46"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "38/50"
  },
  {
    "date": "30-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "30/46"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "45/48"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "20/47"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "31/48"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "40/48"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "40/48"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "30/45"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/45"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "42/50"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/48"
  },
  {
    "date": "30-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "31/45"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "25/46"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "26/46"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/49"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "39/49"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "32/47"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "41/47"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/45"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "25/48"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "41/46"
  },
  {
    "date": "30-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "41/48"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "43/47"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "28/49"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "24/47"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "41/47"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "27/47"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "41/50"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "43/48"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "42/50"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "36/48"
  },
  {
    "date": "30-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "28/47"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "23/47"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "28/45"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/45"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "29/47"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "33/46"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "32/46"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "36/45"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "40/47"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "32/48"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "33/49"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "30/47"
  },
  {
    "date": "30-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "44/48"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "21/46"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "44/47"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "36/46"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "27/46"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "41/45"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "31/47"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "33/48"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "42/49"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "34/45"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "33/49"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "33/50"
  },
  {
    "date": "30-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "20/46"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "32/50"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "32/45"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "21/46"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "30/45"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "29/46"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "42/50"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/45"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "44/45"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "29/49"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "33/50"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "37/50"
  },
  {
    "date": "30-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/50"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "21/48"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/50"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "31/49"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/50"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "38/45"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "27/50"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "39/45"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "27/50"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "40/46"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "24/48"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "30/45"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/45"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "43/47"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "25/47"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "40/46"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "22/47"
  },
  {
    "date": "30-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "30/49"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/49"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "43/46"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/45"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "29/47"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "39/47"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "37/46"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "23/45"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "31/46"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "25/49"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "34/47"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "38/48"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "24/47"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "45/46"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "20/49"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "40/50"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "21/46"
  },
  {
    "date": "30-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/45"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "30/48"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "21/45"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "30/45"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "30/50"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "44/47"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "42/47"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "38/50"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "28/47"
  },
  {
    "date": "30-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/48"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "23/49"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/45"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "22/49"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "43/45"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "28/49"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "30/50"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "30/47"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "35/50"
  },
  {
    "date": "30-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "26/46"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "24/50"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "45/45"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "25/49"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "20/49"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "37/50"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "41/46"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "20/49"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "21/50"
  },
  {
    "date": "31-05-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "31/50"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "21/48"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "40/47"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "42/46"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/49"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "28/49"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "25/45"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/49"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "30/45"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "21/49"
  },
  {
    "date": "31-05-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "24/49"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "30/46"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "37/50"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/46"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "42/49"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "29/48"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "24/50"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "30/49"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "44/45"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "39/45"
  },
  {
    "date": "31-05-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "31/45"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "24/50"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "35/50"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "31/47"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "40/46"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "44/47"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "25/48"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "30/49"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "34/47"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "43/47"
  },
  {
    "date": "31-05-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "20/49"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "37/46"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/46"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "22/47"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "21/48"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "42/48"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "24/48"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "26/49"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "30/49"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "38/45"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/45"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "39/45"
  },
  {
    "date": "31-05-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "34/49"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "21/48"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "20/50"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "32/45"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "45/50"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "44/46"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "22/49"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "22/48"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "31/45"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "24/46"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "40/46"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "20/48"
  },
  {
    "date": "31-05-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "41/46"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "22/50"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "41/48"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "45/47"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "37/47"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "35/50"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "45/48"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "41/48"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "23/45"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "39/49"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "45/50"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "44/48"
  },
  {
    "date": "31-05-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "35/49"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "28/45"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "39/49"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "34/48"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "33/45"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "43/45"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "40/46"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "23/47"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "42/49"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "23/49"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "39/49"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "36/50"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "35/49"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "28/48"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "39/50"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/50"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "40/48"
  },
  {
    "date": "31-05-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "44/50"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "44/49"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/46"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "39/45"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "29/47"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "39/47"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "43/46"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "24/50"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "36/46"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "37/50"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "33/46"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "44/47"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/48"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "44/48"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "29/50"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "40/49"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "33/48"
  },
  {
    "date": "31-05-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "30/49"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "20/45"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "33/45"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "39/49"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "30/47"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "34/48"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "37/50"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "43/45"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "23/48"
  },
  {
    "date": "31-05-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "37/48"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "20/45"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "40/49"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "27/50"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "24/46"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "44/50"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "21/45"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "21/45"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "32/47"
  },
  {
    "date": "31-05-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "35/50"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/46"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "36/49"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "28/48"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "44/46"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "36/46"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "38/49"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/47"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "29/46"
  },
  {
    "date": "02-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "33/47"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "37/50"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "31/48"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "45/47"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "28/49"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "27/46"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "30/46"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/47"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "39/50"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "32/45"
  },
  {
    "date": "02-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "20/50"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "25/50"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/47"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "37/47"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "38/49"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "38/46"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "22/49"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "29/47"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "45/49"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/50"
  },
  {
    "date": "02-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "20/49"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "38/50"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "41/46"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "22/50"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "31/50"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "35/46"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "37/45"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/49"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "23/50"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "33/49"
  },
  {
    "date": "02-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "44/46"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "39/49"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "40/47"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/50"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "40/50"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "23/49"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "39/49"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/45"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "33/47"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "38/50"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "20/45"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "37/45"
  },
  {
    "date": "02-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "21/47"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "33/49"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "40/47"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/50"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "32/48"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "34/48"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "41/46"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "22/48"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "21/47"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "42/49"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "45/46"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "24/50"
  },
  {
    "date": "02-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/45"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "30/47"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "30/49"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/47"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "21/50"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "40/45"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "37/49"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "42/46"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "39/49"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "22/47"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "31/47"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "29/49"
  },
  {
    "date": "02-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "29/47"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "27/47"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "38/49"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "34/48"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "40/45"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "25/50"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "43/47"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "20/46"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "42/49"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "35/45"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "40/47"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "29/50"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "33/50"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "41/48"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "40/47"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "41/50"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "45/47"
  },
  {
    "date": "02-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "24/46"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "40/48"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/49"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "20/50"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "25/46"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/50"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "32/48"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "40/46"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "37/45"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "24/45"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "44/46"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "28/47"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "25/47"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "20/48"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "26/48"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/50"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "44/48"
  },
  {
    "date": "02-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "41/46"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "34/47"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/50"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "44/49"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "40/45"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "33/45"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "31/47"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "36/47"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "27/49"
  },
  {
    "date": "02-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/45"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "42/47"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "44/48"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/47"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "35/49"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "35/47"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "37/48"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "32/49"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "43/47"
  },
  {
    "date": "02-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "32/49"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "32/50"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "24/47"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "30/50"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "28/48"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "33/45"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "32/45"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "35/49"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "27/49"
  },
  {
    "date": "03-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "24/48"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "36/45"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "43/48"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "42/48"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "24/46"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "44/50"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "30/49"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "27/48"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "31/46"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "40/48"
  },
  {
    "date": "03-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/47"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "41/47"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "37/47"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "42/50"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "35/48"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "34/49"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "25/45"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/50"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "37/49"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "40/46"
  },
  {
    "date": "03-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "38/47"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "37/46"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "42/48"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "40/48"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "38/45"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "26/45"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "20/48"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "38/45"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "25/46"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "33/45"
  },
  {
    "date": "03-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "43/46"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "43/48"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "31/46"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "23/49"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "34/46"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "24/48"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "25/46"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "22/50"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "45/48"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "36/45"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "25/47"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "40/48"
  },
  {
    "date": "03-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/49"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "29/49"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "34/50"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "23/50"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/48"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "41/47"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "38/47"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "31/50"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "33/50"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "26/47"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "40/45"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "39/48"
  },
  {
    "date": "03-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "27/50"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/45"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/45"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "36/50"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "41/48"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "20/50"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "36/50"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/50"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "33/47"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "31/45"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "23/50"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "24/46"
  },
  {
    "date": "03-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "22/48"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "44/48"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "36/48"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "28/48"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "38/47"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "39/48"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "27/45"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "42/45"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "43/46"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "27/50"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "36/46"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "42/47"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "43/49"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "23/50"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "27/50"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "35/46"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "22/47"
  },
  {
    "date": "03-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "36/47"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "30/46"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/45"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "42/48"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "28/48"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "43/49"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "36/45"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "37/48"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "35/48"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "27/47"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "44/47"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "33/50"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "22/48"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "21/49"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "34/47"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "31/47"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "23/50"
  },
  {
    "date": "03-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "25/48"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "21/48"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "39/46"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "28/46"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "25/50"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "45/46"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "44/47"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "40/48"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "27/45"
  },
  {
    "date": "03-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/46"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "40/49"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "28/48"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "41/47"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "22/49"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "25/47"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "44/46"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "34/49"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "21/48"
  },
  {
    "date": "03-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/49"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "40/49"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "32/48"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "45/45"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "31/45"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "41/47"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "33/49"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "36/50"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/50"
  },
  {
    "date": "04-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "32/48"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "38/46"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "38/45"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "42/46"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "35/49"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "42/46"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "40/46"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "44/48"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "26/49"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "04-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "39/49"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "36/50"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/47"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "28/47"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "26/49"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "34/46"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "44/46"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/49"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "34/48"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "35/49"
  },
  {
    "date": "04-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "45/48"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "43/46"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "21/50"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "30/46"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/45"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "45/45"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "41/47"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "37/50"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "41/50"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "33/50"
  },
  {
    "date": "04-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/46"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "32/48"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "28/46"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "30/46"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "31/49"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "28/45"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Geography of India",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "31/49"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "29/45"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "27/45"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "34/50"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "22/49"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "24/47"
  },
  {
    "date": "04-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "35/49"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "28/47"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "29/47"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "24/46"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "23/47"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "45/45"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "45/47"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "36/46"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "24/47"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "36/48"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "31/48"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "37/49"
  },
  {
    "date": "04-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "43/45"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "38/46"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "21/46"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/48"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "43/46"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "29/49"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "29/45"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "30/48"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "21/46"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "33/48"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "38/47"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "35/48"
  },
  {
    "date": "04-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "42/47"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "24/46"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "36/46"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "40/47"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "33/49"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "23/47"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Atoms",
    "countStudents": "45/50"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "28/46"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "41/47"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "36/46"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "36/47"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "23/48"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "23/48"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "45/46"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "45/45"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/50"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "27/46"
  },
  {
    "date": "04-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "45/47"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "22/50"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "21/45"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "29/48"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "42/49"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "33/46"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "37/50"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "39/48"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "37/46"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "31/47"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "32/48"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "38/50"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "37/47"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "35/46"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "36/49"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "33/45"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/47"
  },
  {
    "date": "04-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "29/45"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "45/46"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "20/49"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "40/50"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "45/47"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "27/46"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "30/49"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "22/47"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "30/49"
  },
  {
    "date": "04-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "33/47"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "36/45"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/47"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "38/46"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "43/46"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "44/48"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "44/46"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "30/47"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "24/48"
  },
  {
    "date": "04-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "25/50"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "45/50"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "22/46"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/48"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "26/48"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "26/48"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "28/48"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "32/46"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "25/48"
  },
  {
    "date": "05-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "28/45"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "44/47"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/49"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "28/48"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "22/46"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "34/48"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "38/46"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/49"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "25/50"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "37/47"
  },
  {
    "date": "05-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "33/49"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "40/45"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "34/49"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "37/47"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "20/46"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "45/48"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "35/45"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "45/48"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "45/45"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/49"
  },
  {
    "date": "05-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "42/46"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "29/49"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "40/47"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "39/46"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "32/48"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "25/48"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "42/45"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "34/49"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "23/50"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "44/46"
  },
  {
    "date": "05-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/48"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/50"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "26/49"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "27/49"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "32/46"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "32/45"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "27/49"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "30/46"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "37/48"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "32/49"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "21/47"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "32/46"
  },
  {
    "date": "05-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "34/49"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/46"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "24/45"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/47"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "24/48"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "27/45"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "41/47"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "30/48"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "32/49"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "37/49"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "36/46"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "42/48"
  },
  {
    "date": "05-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "27/48"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "34/45"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "37/47"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "21/47"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "43/50"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "37/48"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "27/48"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "22/48"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "20/46"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "40/49"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "33/46"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "45/50"
  },
  {
    "date": "05-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "31/46"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/48"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "28/47"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "24/46"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "23/48"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "31/47"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "23/49"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "26/48"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "36/49"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "21/47"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "39/50"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "20/50"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "21/46"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "22/45"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "45/46"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/47"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "21/47"
  },
  {
    "date": "05-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "20/49"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "37/49"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "24/50"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "41/46"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "39/50"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "26/50"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "38/50"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "45/49"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "29/47"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "45/49"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "35/50"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Banking",
    "homework": false,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "29/49"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "32/48"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "42/47"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "45/47"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "45/50"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "24/45"
  },
  {
    "date": "05-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "27/48"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "27/47"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/45"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "36/46"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Probability",
    "countStudents": "41/45"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "44/46"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "28/45"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "39/47"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "32/48"
  },
  {
    "date": "05-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "24/49"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/48"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "30/49"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/50"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "33/46"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "32/49"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "39/50"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "28/45"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "41/46"
  },
  {
    "date": "05-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "34/47"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "45/49"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "40/50"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "31/46"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "40/45"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "42/45"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "24/50"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/49"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "40/48"
  },
  {
    "date": "06-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "29/46"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/46"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "20/46"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "39/49"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/47"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "25/49"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "45/47"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "22/50"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "44/48"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/49"
  },
  {
    "date": "06-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "41/46"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "42/45"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/49"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "20/50"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/50"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "22/45"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "31/45"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "24/46"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/46"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "23/47"
  },
  {
    "date": "06-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "38/46"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "40/49"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "26/45"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "32/46"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "27/45"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "23/46"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "37/49"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "34/49"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "20/46"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "26/50"
  },
  {
    "date": "06-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/46"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "41/50"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/47"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "25/47"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "36/45"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "32/49"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "41/49"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "42/45"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "35/50"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "36/49"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "20/47"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "20/48"
  },
  {
    "date": "06-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "39/46"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "38/46"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "41/50"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "35/45"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "27/47"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "37/46"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "37/49"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/46"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "43/45"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "39/46"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "32/46"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "39/49"
  },
  {
    "date": "06-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "41/47"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "37/46"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "38/48"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "44/48"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "32/50"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "30/47"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "28/45"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "27/49"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "29/49"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "30/50"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "43/49"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "40/50"
  },
  {
    "date": "06-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "33/48"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "38/49"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "24/48"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "45/46"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "33/48"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "35/49"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "37/48"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Reproduction",
    "countStudents": "28/49"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "36/46"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "24/50"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "25/49"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "42/45"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "21/50"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "33/49"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "37/50"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "38/47"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "39/46"
  },
  {
    "date": "06-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "28/45"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "35/47"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "32/50"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/46"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/50"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "38/49"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "29/45"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "24/46"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "20/47"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "38/45"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "29/48"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "32/48"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "45/49"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "20/48"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "29/49"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "45/50"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "39/46"
  },
  {
    "date": "06-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/50"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "32/47"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "42/45"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "23/50"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "33/49"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "23/49"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "30/47"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "26/49"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "34/49"
  },
  {
    "date": "06-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/45"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "37/48"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "43/48"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "35/50"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "22/49"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "40/45"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "37/50"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "21/48"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "43/50"
  },
  {
    "date": "06-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "37/46"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "31/45"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "30/45"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "41/48"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "24/48"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "44/46"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "36/49"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "34/47"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "30/48"
  },
  {
    "date": "07-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "32/45"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "21/48"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "32/46"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "42/45"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "39/49"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "21/45"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "26/47"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "28/46"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "24/50"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "38/49"
  },
  {
    "date": "07-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "28/46"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "35/47"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "43/50"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "31/46"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "28/47"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "40/47"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "44/50"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "28/48"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "28/46"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/45"
  },
  {
    "date": "07-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "25/49"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "27/48"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "41/46"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "30/49"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/50"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "33/45"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "29/46"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "28/46"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/49"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "29/46"
  },
  {
    "date": "07-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "32/48"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "26/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "27/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "38/49"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "32/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "38/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/48"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "43/48"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "24/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "43/47"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "31/45"
  },
  {
    "date": "07-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "36/49"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "24/49"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "30/49"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "33/46"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "36/50"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "41/47"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "22/48"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/50"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "42/48"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "22/46"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "44/45"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "35/45"
  },
  {
    "date": "07-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "28/47"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "25/50"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/50"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "31/50"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "44/48"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "39/46"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "45/48"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "25/46"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "27/49"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "21/47"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "38/48"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "25/50"
  },
  {
    "date": "07-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "27/47"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "23/47"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "37/46"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "36/49"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "24/48"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "27/50"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "43/45"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "23/50"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "45/48"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "25/45"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "37/45"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "21/50"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "37/45"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "44/45"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "36/47"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "22/50"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "33/47"
  },
  {
    "date": "07-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "41/48"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/46"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/50"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/46"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "31/48"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "25/45"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "43/50"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "28/46"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "26/47"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "32/45"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "29/47"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "35/45"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "27/47"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "31/46"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "26/49"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "30/49"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "25/46"
  },
  {
    "date": "07-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "41/46"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "44/46"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "32/45"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "20/45"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "40/50"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Determinants",
    "countStudents": "20/46"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "42/48"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "45/47"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "26/50"
  },
  {
    "date": "07-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "41/48"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "33/48"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "26/46"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "21/49"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "26/48"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "30/49"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "26/49"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "24/47"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "38/45"
  },
  {
    "date": "07-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/50"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "24/50"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "41/47"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "23/46"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "39/45"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "41/48"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "43/50"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/48"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "43/45"
  },
  {
    "date": "09-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "23/47"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "39/48"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "43/46"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "20/49"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "34/46"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "24/48"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "42/47"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "20/48"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "24/46"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "32/46"
  },
  {
    "date": "09-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "34/46"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "41/46"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/50"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/45"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "33/50"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "44/47"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "35/49"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "41/47"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "32/47"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "27/50"
  },
  {
    "date": "09-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "28/50"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "36/45"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "30/50"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "35/48"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "35/46"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "39/45"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "33/45"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/47"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "27/48"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "31/47"
  },
  {
    "date": "09-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "43/49"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "26/46"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/46"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/49"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "34/50"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "25/46"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "24/50"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/48"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "44/49"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "40/46"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "42/50"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "42/49"
  },
  {
    "date": "09-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/48"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "39/50"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "37/47"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "20/48"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "38/48"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "29/45"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "41/45"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/48"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "22/45"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "40/46"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "32/45"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "25/47"
  },
  {
    "date": "09-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "31/49"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "30/50"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "22/45"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "28/50"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "22/46"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "22/49"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "41/50"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/45"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "40/50"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "35/45"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "36/47"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "23/47"
  },
  {
    "date": "09-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "24/48"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "26/50"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "26/48"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "31/48"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "27/49"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "25/45"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "30/49"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "44/48"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "36/49"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Constitution",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "37/49"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": false,
    "homeworkVal": "Landforms",
    "countStudents": "25/45"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Money",
    "countStudents": "40/48"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "33/50"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "38/45"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "35/49"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "25/50"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "23/47"
  },
  {
    "date": "09-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "43/45"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "38/47"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/48"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "26/47"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "39/50"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "43/49"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "27/45"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "42/49"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Mughal Empire",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "35/48"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "26/46"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "27/46"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Budget",
    "countStudents": "42/45"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "26/50"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "Data Handling",
    "countStudents": "30/48"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "42/48"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "42/46"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "41/48"
  },
  {
    "date": "09-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "30/48"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "30/47"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "32/45"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/45"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "43/50"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "27/46"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "44/46"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "29/47"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "21/49"
  },
  {
    "date": "09-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "21/46"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "26/50"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/45"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "40/46"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "37/46"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "38/49"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "35/49"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "34/46"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "36/46"
  },
  {
    "date": "09-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "40/49"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "45/50"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "39/49"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "35/45"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "31/47"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "31/49"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "38/45"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/46"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "30/46"
  },
  {
    "date": "10-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "31/48"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "45/45"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "41/49"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "23/48"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "23/49"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "39/48"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "39/45"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/45"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "45/47"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "38/49"
  },
  {
    "date": "10-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "32/50"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "27/47"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "32/47"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "40/48"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "43/46"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "33/47"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "35/48"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "31/45"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "41/45"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "40/46"
  },
  {
    "date": "10-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "21/46"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "24/46"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "36/50"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "31/48"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "39/47"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "35/50"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "45/45"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "41/50"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "28/50"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "35/46"
  },
  {
    "date": "10-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "28/45"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "32/49"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "22/48"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "32/48"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "23/45"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "23/47"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "36/46"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "43/47"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "33/49"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "41/47"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "41/48"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "45/49"
  },
  {
    "date": "10-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/50"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "36/45"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "36/50"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "24/45"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "36/47"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "29/45"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "27/47"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "45/50"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "30/48"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "36/45"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "32/49"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "41/48"
  },
  {
    "date": "10-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "44/46"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "36/50"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "26/45"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "27/47"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "31/45"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "37/46"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "43/50"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "42/48"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "36/46"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "37/50"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "25/50"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "31/47"
  },
  {
    "date": "10-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "43/50"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/47"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "27/49"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "39/50"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "25/48"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "44/48"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "45/49"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "41/50"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "29/46"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "41/50"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": false,
    "homeworkVal": "Population",
    "countStudents": "24/50"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "33/46"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "24/49"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "36/50"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": false,
    "homeworkVal": "Grammar Rules",
    "countStudents": "28/49"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "35/45"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "42/46"
  },
  {
    "date": "10-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "43/49"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "42/49"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "33/49"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "34/50"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "23/50"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "35/47"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "27/49"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "43/45"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "41/45"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "34/50"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "23/50"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "23/49"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/46"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/49"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "21/47"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "31/46"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "25/48"
  },
  {
    "date": "10-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "39/45"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/47"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "23/47"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "34/46"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "35/47"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "27/47"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "28/49"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "35/46"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "33/46"
  },
  {
    "date": "10-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "41/46"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "28/48"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "26/50"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "43/50"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "21/49"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "35/47"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "40/47"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "20/47"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "40/45"
  },
  {
    "date": "10-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "30/45"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "21/50"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "30/47"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "30/45"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "31/50"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "22/50"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "33/47"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "24/45"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/47"
  },
  {
    "date": "11-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "36/47"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "33/45"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/46"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/47"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "30/47"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "42/50"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "26/45"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "41/46"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "43/46"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "30/45"
  },
  {
    "date": "11-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "30/45"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "24/45"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "25/45"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "31/45"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "27/48"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "43/48"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "20/46"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "31/46"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "39/49"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "31/47"
  },
  {
    "date": "11-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "31/48"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "27/49"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "42/50"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "22/46"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "30/46"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "26/50"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "20/47"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "37/45"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/46"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "40/50"
  },
  {
    "date": "11-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "34/48"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "25/49"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "40/49"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/49"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "21/49"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "40/45"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "22/47"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "29/46"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "26/46"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "44/45"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "34/49"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "37/47"
  },
  {
    "date": "11-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "41/47"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "39/47"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "24/49"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "38/50"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "45/48"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "41/47"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "45/48"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/45"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "20/47"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "41/47"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "24/50"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "44/46"
  },
  {
    "date": "11-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "23/48"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "24/46"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "32/50"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/47"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "36/48"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "30/50"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "20/47"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "45/46"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "34/47"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "29/50"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "28/47"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "32/47"
  },
  {
    "date": "11-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "21/47"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "35/50"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "39/46"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "33/46"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "25/47"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "39/48"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "42/46"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "32/47"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "Ancient India",
    "countStudents": "43/47"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "21/49"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "35/45"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "38/45"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "36/49"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "42/48"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "36/48"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/46"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "20/45"
  },
  {
    "date": "11-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "22/48"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "20/45"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "39/46"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "32/49"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "39/46"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "41/46"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "43/49"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "20/49"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "33/46"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "37/47"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Climate",
    "countStudents": "43/47"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "25/47"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "25/48"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "33/45"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "45/46"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "37/48"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "41/46"
  },
  {
    "date": "11-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/47"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "41/45"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "21/49"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "26/49"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "33/49"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "42/50"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/48"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "26/47"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "21/45"
  },
  {
    "date": "11-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "45/49"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "43/48"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "23/45"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "38/48"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "21/48"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "28/47"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "44/45"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "40/46"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "29/49"
  },
  {
    "date": "11-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "35/45"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "36/46"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "20/48"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "45/50"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "21/49"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "37/48"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "28/50"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/46"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "27/50"
  },
  {
    "date": "12-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "35/45"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "20/47"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "22/48"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "39/48"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "24/49"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "38/49"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "44/49"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "23/48"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "22/47"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/45"
  },
  {
    "date": "12-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/45"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "21/48"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "28/45"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "35/50"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "43/45"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "20/49"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Pollution",
    "countStudents": "21/49"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/49"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "23/49"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "23/46"
  },
  {
    "date": "12-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "33/46"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "27/50"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "24/46"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "31/50"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "37/46"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Sketching",
    "countStudents": "24/48"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "28/50"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/46"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/47"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "27/48"
  },
  {
    "date": "12-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/45"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "25/50"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "25/47"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/50"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "28/47"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "35/48"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "23/48"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "21/48"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "27/45"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "37/49"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/50"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "39/46"
  },
  {
    "date": "12-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "41/47"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "44/50"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "25/49"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "45/50"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/46"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "43/47"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "35/50"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/49"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/45"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "30/48"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "41/49"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "36/45"
  },
  {
    "date": "12-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "32/50"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "37/49"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "29/47"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "32/48"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "26/46"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "23/46"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "40/49"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "33/46"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "36/47"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/49"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "42/47"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "32/49"
  },
  {
    "date": "12-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/49"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "43/48"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "42/45"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "26/46"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "42/50"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "30/50"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "42/46"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "45/49"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "33/46"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "37/46"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Climate",
    "countStudents": "27/47"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "45/46"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "28/49"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/50"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "43/49"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "40/50"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "38/49"
  },
  {
    "date": "12-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "28/49"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "44/49"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "44/47"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "21/48"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "39/49"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "20/45"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "41/46"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "41/45"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "Ancient India",
    "countStudents": "45/49"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Indian Constitution",
    "countStudents": "36/48"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "33/50"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "33/48"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "30/47"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "21/47"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/50"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "30/45"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "42/49"
  },
  {
    "date": "12-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "42/50"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "24/48"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "32/46"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "30/49"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "32/46"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "37/48"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "22/50"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "41/45"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "23/46"
  },
  {
    "date": "12-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "43/46"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "23/45"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "35/45"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "20/50"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "20/46"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "38/46"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "39/47"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "39/46"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "29/45"
  },
  {
    "date": "12-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "34/45"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "26/48"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "32/49"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "23/46"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "42/45"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "39/48"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "28/46"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "40/46"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "42/48"
  },
  {
    "date": "13-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "40/46"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "29/45"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "26/48"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "42/49"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "38/49"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "29/50"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "34/46"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "45/47"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/46"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "37/49"
  },
  {
    "date": "13-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/48"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "32/45"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "41/46"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "26/46"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "23/49"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "35/50"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "28/46"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "25/47"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "21/48"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "25/50"
  },
  {
    "date": "13-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "37/48"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "36/45"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "32/46"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "25/46"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "40/48"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "42/49"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "38/47"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "44/47"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "40/45"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "32/48"
  },
  {
    "date": "13-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "27/45"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "44/46"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/49"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "36/48"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "29/46"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "31/50"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "39/46"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "29/45"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "25/45"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "36/49"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "36/45"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "43/50"
  },
  {
    "date": "13-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "26/46"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "36/45"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/50"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/49"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "43/48"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "42/47"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "41/50"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "42/45"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "45/45"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "29/46"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "35/48"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "42/48"
  },
  {
    "date": "13-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "36/50"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "24/47"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/49"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "35/49"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "27/50"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "25/46"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "Resources",
    "countStudents": "37/49"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/45"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "44/48"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "41/46"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "33/49"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "33/45"
  },
  {
    "date": "13-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "23/48"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "26/50"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "35/45"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "35/45"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "43/46"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "32/48"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "26/45"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "40/48"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "44/45"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "24/49"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "27/50"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "33/49"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "36/46"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/47"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "21/45"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "26/49"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "20/45"
  },
  {
    "date": "13-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "28/47"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "21/45"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/46"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "27/46"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "45/45"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "24/46"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "20/49"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "27/49"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Ancient India",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "21/50"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "32/49"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Population",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "40/50"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "21/49"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "37/47"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "MS Office",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "22/50"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "38/45"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "24/45"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "41/50"
  },
  {
    "date": "13-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "42/46"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "42/46"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "39/49"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "29/50"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "39/47"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "40/46"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "23/48"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "22/48"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "22/50"
  },
  {
    "date": "13-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/49"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "36/45"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/46"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "31/47"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "29/46"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "34/49"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "25/50"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "40/48"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Respiration",
    "countStudents": "21/47"
  },
  {
    "date": "13-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/48"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "24/48"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "25/50"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "36/50"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "40/48"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "45/46"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "37/45"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "21/45"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "45/46"
  },
  {
    "date": "14-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "22/47"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Comprehension",
    "countStudents": "35/47"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "28/48"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "21/50"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "44/47"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": true,
    "homeworkVal": "Shading",
    "countStudents": "39/50"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "42/45"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "44/49"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "34/46"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "30/46"
  },
  {
    "date": "14-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "41/49"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Active Voice",
    "countStudents": "43/47"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "33/46"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "31/45"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "35/47"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "23/48"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "31/45"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "27/48"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "39/45"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "26/49"
  },
  {
    "date": "14-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "40/47"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "28/50"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Nouns",
    "countStudents": "28/46"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/47"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "30/46"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "36/50"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "30/48"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "32/45"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/45"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "23/49"
  },
  {
    "date": "14-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "42/48"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "32/48"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "23/47"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "22/45"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "30/46"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "25/50"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "30/45"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "23/45"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "28/45"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "30/46"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "37/45"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "25/50"
  },
  {
    "date": "14-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "38/46"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "21/49"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "24/49"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "37/47"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "31/49"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "28/47"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "28/46"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "34/48"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "32/49"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "45/49"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "28/50"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "25/48"
  },
  {
    "date": "14-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "31/50"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "32/47"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "38/46"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "33/49"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "34/50"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "38/47"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "31/49"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/50"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Data Types",
    "countStudents": "28/48"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/50"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "36/49"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "24/47"
  },
  {
    "date": "14-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "27/50"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "24/50"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "36/49"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "21/50"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "32/46"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "43/49"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "32/47"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "20/47"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "37/48"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "35/45"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "27/47"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Economic Growth",
    "countStudents": "38/50"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "26/49"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "25/47"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "40/50"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "24/47"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "25/45"
  },
  {
    "date": "14-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "22/49"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "39/48"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "22/49"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "45/48"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "40/45"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Sound",
    "countStudents": "23/48"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "33/48"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "40/45"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "45/47"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": true,
    "homeworkVal": "Government",
    "countStudents": "32/45"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "37/46"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "36/46"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "35/49"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Digital Citizenship",
    "homework": false,
    "homeworkVal": "Data Handling",
    "countStudents": "40/48"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "41/49"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "28/46"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "39/45"
  },
  {
    "date": "14-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "36/50"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "22/49"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/46"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/48"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "24/46"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Differentiation",
    "countStudents": "39/47"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Work and Energy",
    "countStudents": "26/47"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "30/45"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "31/46"
  },
  {
    "date": "14-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/47"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "26/48"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/46"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/47"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Trigonometry",
    "countStudents": "26/46"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "27/49"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "36/49"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Acids and Bases",
    "countStudents": "27/45"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Reproduction",
    "countStudents": "31/49"
  },
  {
    "date": "14-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "21/48"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "43/49"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "33/48"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "38/50"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "37/49"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "22/48"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Plants",
    "countStudents": "43/47"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "27/50"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "27/50"
  },
  {
    "date": "16-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "44/46"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "29/46"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "24/48"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "22/45"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "42/46"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "40/45"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "20/45"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "41/47"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "22/48"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "20/49"
  },
  {
    "date": "16-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "32/48"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "27/48"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "34/46"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "33/47"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "41/48"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "42/46"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Animals",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "39/50"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "25/48"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/48"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "45/49"
  },
  {
    "date": "16-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "29/47"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "44/49"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "34/46"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "22/47"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "32/45"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Shading",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "25/47"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Plants",
    "countStudents": "25/46"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "38/45"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "45/47"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Sargam",
    "countStudents": "45/49"
  },
  {
    "date": "16-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "21/50"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "34/46"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "34/47"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/47"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "31/47"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "25/49"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "43/47"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "29/50"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "40/45"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "37/45"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "20/50"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "36/47"
  },
  {
    "date": "16-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "23/46"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Drama",
    "countStudents": "30/48"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "33/50"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "37/50"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "39/49"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Human Body",
    "homework": false,
    "homeworkVal": "Photosynthesis",
    "countStudents": "36/46"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Geography of India",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "27/50"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "32/45"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "27/45"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "42/46"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "28/50"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "21/47"
  },
  {
    "date": "16-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "40/48"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "30/49"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "28/46"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "31/49"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "45/48"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "29/49"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": true,
    "homeworkVal": "Geography of India",
    "countStudents": "29/46"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "32/46"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "42/47"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "34/48"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "38/49"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Warm-up",
    "countStudents": "43/50"
  },
  {
    "date": "16-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "36/47"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/47"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "42/45"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "23/48"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "45/48"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Sound",
    "countStudents": "40/50"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "44/50"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "39/48"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "38/48"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "45/48"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Natural Resources",
    "homework": true,
    "homeworkVal": "Population",
    "countStudents": "40/45"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "42/50"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/45"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "29/50"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "24/48"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Book Review",
    "countStudents": "29/49"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "33/50"
  },
  {
    "date": "16-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "31/46"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "35/49"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "45/48"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "37/50"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "27/45"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "31/49"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "22/47"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "31/50"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "British Rule",
    "countStudents": "30/45"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "34/48"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "33/45"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Budget",
    "homework": false,
    "homeworkVal": "Money",
    "countStudents": "26/45"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "30/45"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Digital Citizenship",
    "homework": true,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "30/45"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "44/48"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "23/49"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "23/48"
  },
  {
    "date": "16-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "30/47"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "39/49"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "21/45"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "44/50"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "20/49"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Determinants",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "24/47"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/47"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "23/50"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "45/46"
  },
  {
    "date": "16-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/45"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "24/47"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "45/45"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "43/49"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Probability",
    "countStudents": "42/45"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Matrices",
    "countStudents": "33/47"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Gravitation",
    "countStudents": "39/49"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "32/45"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "38/48"
  },
  {
    "date": "16-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "41/46"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Tenses",
    "countStudents": "42/50"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "25/50"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "23/49"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "India States",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "30/49"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "23/45"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "31/48"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "29/48"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "24/50"
  },
  {
    "date": "17-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": true,
    "homeworkVal": "Data Types",
    "countStudents": "33/45"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "20/46"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "36/47"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "27/45"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "25/45"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "20/50"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": false,
    "homeworkVal": "Life Cycle",
    "countStudents": "31/45"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/50"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Bhajan",
    "countStudents": "43/49"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "27/48"
  },
  {
    "date": "17-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "30/49"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "21/49"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Tatsam-Tadbhav",
    "countStudents": "31/46"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "23/50"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "42/48"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "29/50"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "34/48"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/46"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "39/49"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Instrument Practice",
    "countStudents": "45/47"
  },
  {
    "date": "17-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "29/47"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": false,
    "homeworkVal": "Adjectives",
    "countStudents": "41/45"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "35/48"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "37/47"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "26/50"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Shading",
    "countStudents": "43/45"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "43/47"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "38/50"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "35/48"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "44/48"
  },
  {
    "date": "17-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "28/47"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "38/49"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "28/49"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "23/47"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Division",
    "countStudents": "40/47"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "31/45"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "Civics Duties",
    "countStudents": "22/50"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "35/47"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "39/48"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "22/46"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "21/48"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "28/50"
  },
  {
    "date": "17-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "22/46"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "45/49"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "41/49"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kahani",
    "countStudents": "25/49"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "40/45"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "34/47"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Indian Freedom Struggle",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "34/45"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "43/48"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "29/50"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Famous Personalities",
    "countStudents": "27/46"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "39/46"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "32/45"
  },
  {
    "date": "17-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/48"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "26/50"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "30/50"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "22/46"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "38/45"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "23/50"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "27/49"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "32/48"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "36/46"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "India States",
    "countStudents": "41/46"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "31/46"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "42/48"
  },
  {
    "date": "17-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "33/46"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "27/46"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "40/50"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "31/50"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "34/49"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "28/49"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "36/48"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "25/48"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "British Rule",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "21/45"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Fundamental Rights",
    "countStudents": "35/49"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Landforms",
    "countStudents": "37/45"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "35/50"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "45/46"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "MS Office",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "23/50"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "33/48"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "39/50"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Athletics",
    "countStudents": "33/46"
  },
  {
    "date": "17-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "33/50"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "42/46"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "25/45"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "22/50"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "38/49"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "32/47"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Periodic Table",
    "countStudents": "31/50"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "40/50"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Ancient India",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "31/46"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Elections",
    "countStudents": "23/46"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Natural Resources",
    "countStudents": "43/46"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "24/50"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "28/48"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Digital Citizenship",
    "countStudents": "21/49"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "21/49"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Reading Hour",
    "countStudents": "27/45"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "41/49"
  },
  {
    "date": "17-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "23/50"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "37/50"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "33/49"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Vyakaran",
    "countStudents": "31/47"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Calculus",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "33/49"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Integration",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "38/50"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "40/47"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "43/45"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "29/49"
  },
  {
    "date": "17-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "23/46"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "32/50"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "38/46"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "24/45"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "36/49"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Integration",
    "countStudents": "20/47"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "33/47"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "20/48"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "30/49"
  },
  {
    "date": "17-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "40/48"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "27/50"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "42/45"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "42/45"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "33/46"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "22/49"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "30/47"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "26/49"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "28/49"
  },
  {
    "date": "18-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "23/49"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "26/49"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "21/50"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "24/50"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "20/49"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Sketching",
    "countStudents": "29/49"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "22/49"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "43/47"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "22/45"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "35/45"
  },
  {
    "date": "18-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "42/50"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Active Voice",
    "countStudents": "30/49"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Muhavare",
    "homework": true,
    "homeworkVal": "Muhavare",
    "countStudents": "37/49"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "44/48"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "42/49"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Scenery Drawing",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "30/46"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "39/48"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "27/46"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Scratch Coding",
    "countStudents": "29/49"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "26/49"
  },
  {
    "date": "18-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Famous Authors",
    "countStudents": "21/50"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Comprehension",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "39/49"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Muhavare",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "24/47"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "29/47"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "31/47"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Coloring",
    "homework": false,
    "homeworkVal": "Coloring",
    "countStudents": "29/47"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Plants",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "44/46"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "43/47"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "34/48"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "40/47"
  },
  {
    "date": "18-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "32/46"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "25/47"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "27/47"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "40/46"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "31/48"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Photosynthesis",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "34/45"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "28/47"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/48"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "30/49"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "42/48"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "44/49"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "42/46"
  },
  {
    "date": "18-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Reading Hour",
    "countStudents": "34/46"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "32/48"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Anuchhed",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "43/48"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "39/48"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "23/47"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Photosynthesis",
    "countStudents": "43/46"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Resources",
    "countStudents": "44/45"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "26/48"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "43/48"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "38/47"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Sentence Formation",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "44/45"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Cricket",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "30/45"
  },
  {
    "date": "18-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "30/45"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "45/50"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "34/45"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "45/47"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Multiplication",
    "countStudents": "40/48"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Photosynthesis",
    "homework": false,
    "homeworkVal": "Human Body",
    "countStudents": "21/49"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "29/47"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "33/50"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Data Types",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "28/48"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "39/47"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "24/47"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "22/50"
  },
  {
    "date": "18-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "34/46"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/49"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "30/47"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "45/49"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "38/49"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Laws of Motion",
    "countStudents": "21/48"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "24/46"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Diseases",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "44/50"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Modern History",
    "countStudents": "35/45"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Democracy",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "40/47"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Agriculture",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "32/47"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Economic Growth",
    "countStudents": "43/49"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "22/48"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "HTML Basics",
    "countStudents": "23/50"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "29/46"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "31/46"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Yoga",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "44/47"
  },
  {
    "date": "18-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": false,
    "homeworkVal": "Sargam",
    "countStudents": "23/46"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "33/49"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "45/47"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "20/50"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "21/48"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "34/47"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "35/50"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "36/49"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "43/50"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Democracy",
    "homework": true,
    "homeworkVal": "Elections",
    "countStudents": "27/48"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "42/47"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "43/46"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "35/47"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "25/46"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Greetings",
    "countStudents": "37/46"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "41/46"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": true,
    "homeworkVal": "Football",
    "countStudents": "43/48"
  },
  {
    "date": "18-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "26/47"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "35/50"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "45/48"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "42/50"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "34/49"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "42/47"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "41/50"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Mixtures",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "43/46"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "29/47"
  },
  {
    "date": "18-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "42/46"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/48"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "39/50"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "32/48"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "45/47"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Integration",
    "countStudents": "41/49"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "31/48"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Atoms",
    "countStudents": "41/45"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Respiration",
    "countStudents": "42/48"
  },
  {
    "date": "18-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/49"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "40/50"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "45/47"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "35/46"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": true,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "34/47"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "43/48"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Pollution",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "28/46"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "24/45"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Instrument Practice",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "35/48"
  },
  {
    "date": "19-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "21/47"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "20/49"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "34/49"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "39/48"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "25/48"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "28/49"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "22/49"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "44/46"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "30/47"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "MS Word",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "30/45"
  },
  {
    "date": "19-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "22/48"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Adjectives",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "26/49"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Tatsam-Tadbhav",
    "homework": false,
    "homeworkVal": "Muhavare",
    "countStudents": "37/45"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": true,
    "homeworkVal": "Division",
    "countStudents": "31/48"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "35/47"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": true,
    "homeworkVal": "Coloring",
    "countStudents": "23/46"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Animals",
    "countStudents": "22/50"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "38/48"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "41/50"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Sargam",
    "homework": true,
    "homeworkVal": "Bhajan",
    "countStudents": "29/49"
  },
  {
    "date": "19-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Library Rules",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "22/50"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "25/45"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Samas",
    "countStudents": "41/45"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "32/47"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "26/45"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "29/49"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Pollution",
    "countStudents": "30/49"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "26/45"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "23/47"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "36/48"
  },
  {
    "date": "19-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "36/46"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "34/48"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "38/45"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "27/47"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "31/47"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": false,
    "homeworkVal": "Electricity",
    "countStudents": "35/50"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "37/47"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "45/50"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Scratch Coding",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "43/49"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "31/48"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Greetings",
    "countStudents": "23/46"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Cricket",
    "countStudents": "29/46"
  },
  {
    "date": "19-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "28/46"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "26/47"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "24/45"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "41/45"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "23/45"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "42/45"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "World Wars",
    "countStudents": "35/50"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "42/48"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Data Types",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "45/47"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Facts",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/49"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "33/48"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Warm-up",
    "homework": false,
    "homeworkVal": "Yoga",
    "countStudents": "23/48"
  },
  {
    "date": "19-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Silent Reading",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/48"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": false,
    "homeworkVal": "Grammar",
    "countStudents": "36/49"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "33/48"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "22/46"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "38/48"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Electricity",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "37/45"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "World Wars",
    "homework": false,
    "homeworkVal": "Geography of India",
    "countStudents": "37/48"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Verb Forms",
    "countStudents": "27/45"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "MS Word",
    "countStudents": "29/49"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Famous Personalities",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "30/45"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": true,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "36/50"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "28/47"
  },
  {
    "date": "19-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "21/50"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "28/47"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "26/49"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Nibandh",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "21/49"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Division",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "37/45"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": true,
    "homeworkVal": "Light",
    "countStudents": "22/47"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "39/49"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": true,
    "homeworkVal": "Cells",
    "countStudents": "43/48"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Modern History",
    "homework": true,
    "homeworkVal": "Mughal Empire",
    "countStudents": "35/45"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Government",
    "homework": false,
    "homeworkVal": "Indian Constitution",
    "countStudents": "38/47"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Landforms",
    "homework": false,
    "homeworkVal": "Agriculture",
    "countStudents": "39/48"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Banking",
    "homework": true,
    "homeworkVal": "Banking",
    "countStudents": "33/45"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Verb Forms",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "45/45"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "MS Office",
    "countStudents": "45/47"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "38/48"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Famous Authors",
    "countStudents": "39/50"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "37/50"
  },
  {
    "date": "19-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "20/46"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "20/49"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "39/49"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "26/48"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Algebra",
    "countStudents": "34/45"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Sound",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "26/45"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "43/46"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Nutrition",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "20/48"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Wars",
    "homework": true,
    "homeworkVal": "Modern History",
    "countStudents": "24/47"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Elections",
    "homework": true,
    "homeworkVal": "Democracy",
    "countStudents": "27/48"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Natural Resources",
    "countStudents": "40/48"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Economic Growth",
    "homework": false,
    "homeworkVal": "Budget",
    "countStudents": "27/49"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Translation",
    "countStudents": "27/46"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Data Handling",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/49"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Grammar Rules",
    "homework": true,
    "homeworkVal": "Conjugation",
    "countStudents": "27/48"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Library Rules",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "31/50"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": true,
    "homeworkVal": "Yoga",
    "countStudents": "32/47"
  },
  {
    "date": "19-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "41/48"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "40/50"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "45/45"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "26/48"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Probability",
    "homework": false,
    "homeworkVal": "Trigonometry",
    "countStudents": "29/47"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Statistics",
    "homework": false,
    "homeworkVal": "Matrices",
    "countStudents": "22/45"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "21/49"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Acids and Bases",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "41/47"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "25/48"
  },
  {
    "date": "19-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "39/46"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Literature",
    "countStudents": "32/47"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "31/48"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Kahani",
    "homework": false,
    "homeworkVal": "Kavita",
    "countStudents": "45/47"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Trigonometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "36/45"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Matrices",
    "homework": false,
    "homeworkVal": "Statistics",
    "countStudents": "43/48"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": true,
    "homeworkVal": "Laws of Motion",
    "countStudents": "40/50"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Acids and Bases",
    "homework": true,
    "homeworkVal": "Chemical Reactions",
    "countStudents": "42/48"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Diseases",
    "countStudents": "33/48"
  },
  {
    "date": "19-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "38/49"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "English",
    "teacher": "Deepak Mishra",
    "classwork": false,
    "classworkVal": "Active Voice",
    "homework": false,
    "homeworkVal": "Tenses",
    "countStudents": "39/50"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "Hindi",
    "teacher": "S.P. Dixit",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "36/50"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "Math",
    "teacher": "Ankit D Souza",
    "classwork": true,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Algebra",
    "countStudents": "20/45"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "G.K.",
    "teacher": "Francis James",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "Current Affairs",
    "countStudents": "22/45"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "Drawing",
    "teacher": "Ankit D Souza",
    "classwork": false,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "40/48"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "E.V.S.",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Plants",
    "homework": false,
    "homeworkVal": "Animals",
    "countStudents": "28/46"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "Sanskrit",
    "teacher": "S.P. Dixit",
    "classwork": true,
    "classworkVal": "Verb Forms",
    "homework": true,
    "homeworkVal": "Samas",
    "countStudents": "34/46"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "Music",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Bhajan",
    "homework": false,
    "homeworkVal": "Patriotic Song",
    "countStudents": "29/47"
  },
  {
    "date": "20-06-2025",
    "class": "II-A",
    "subject": "Computer",
    "teacher": "Deepak Mishra",
    "classwork": true,
    "classworkVal": "Scratch Coding",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "42/48"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "English",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Active Voice",
    "homework": true,
    "homeworkVal": "Grammar",
    "countStudents": "22/49"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "33/48"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "44/47"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "G.K.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": true,
    "homeworkVal": "World Facts",
    "countStudents": "26/48"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Coloring",
    "homework": true,
    "homeworkVal": "Still Life",
    "countStudents": "34/48"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "E.V.S.",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Life Cycle",
    "homework": false,
    "homeworkVal": "Water Cycle",
    "countStudents": "24/46"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "39/49"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Patriotic Song",
    "homework": false,
    "homeworkVal": "Instrument Practice",
    "countStudents": "32/50"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Computer",
    "teacher": "Aditya Verma",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": false,
    "homeworkVal": "Scratch Coding",
    "countStudents": "33/49"
  },
  {
    "date": "20-06-2025",
    "class": "III-A",
    "subject": "Library",
    "teacher": "Aditya Verma",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Library Rules",
    "countStudents": "39/47"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Comprehension",
    "countStudents": "43/50"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": false,
    "homeworkVal": "Nouns",
    "countStudents": "37/48"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": true,
    "classworkVal": "Fractions",
    "homework": false,
    "homeworkVal": "Fractions",
    "countStudents": "30/50"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "G.K.",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "General Knowledge Quiz",
    "homework": false,
    "homeworkVal": "World Facts",
    "countStudents": "44/49"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": true,
    "classworkVal": "Sketching",
    "homework": false,
    "homeworkVal": "Still Life",
    "countStudents": "42/50"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Life Cycle",
    "homework": true,
    "homeworkVal": "Water Cycle",
    "countStudents": "20/49"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Verb Forms",
    "countStudents": "21/47"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Internet Safety",
    "countStudents": "28/46"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": false,
    "homeworkVal": "Practice Raag",
    "countStudents": "30/46"
  },
  {
    "date": "20-06-2025",
    "class": "IV-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "24/46"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "English",
    "teacher": "All In One",
    "classwork": true,
    "classworkVal": "Tenses",
    "homework": true,
    "homeworkVal": "Adjectives",
    "countStudents": "41/48"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Hindi",
    "teacher": "Harsh Munda",
    "classwork": false,
    "classworkVal": "Nouns",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "43/49"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Math",
    "teacher": "Kirti Vimal",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "25/48"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "G.K.",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "Current Affairs",
    "countStudents": "41/50"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Drawing",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Still Life",
    "homework": false,
    "homeworkVal": "Scenery Drawing",
    "countStudents": "45/50"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "E.V.S.",
    "teacher": "Gaurav Tiwari",
    "classwork": false,
    "classworkVal": "Water Cycle",
    "homework": true,
    "homeworkVal": "Life Cycle",
    "countStudents": "24/48"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Sanskrit",
    "teacher": "Harsh Munda",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "29/46"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Computer",
    "teacher": "All In One",
    "classwork": false,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Internet Safety",
    "countStudents": "36/48"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Music",
    "teacher": "kavya menon",
    "classwork": false,
    "classworkVal": "Practice Raag",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "23/49"
  },
  {
    "date": "20-06-2025",
    "class": "V-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Book Review",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "22/50"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Drama",
    "countStudents": "30/48"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": true,
    "homeworkVal": "Anuchhed",
    "countStudents": "37/49"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "38/45"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Math",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "45/49"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Science",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Human Body",
    "homework": true,
    "homeworkVal": "Magnetism",
    "countStudents": "38/46"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": false,
    "homeworkVal": "Indian Freedom Struggle",
    "countStudents": "44/50"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Shlok Recitation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "38/47"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "Input Devices",
    "countStudents": "22/49"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Current Affairs",
    "homework": false,
    "homeworkVal": "India States",
    "countStudents": "43/50"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Conjugation",
    "homework": false,
    "homeworkVal": "Conjugation",
    "countStudents": "27/49"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Athletics",
    "homework": false,
    "homeworkVal": "Athletics",
    "countStudents": "28/47"
  },
  {
    "date": "20-06-2025",
    "class": "VI-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Famous Authors",
    "homework": false,
    "homeworkVal": "Book Review",
    "countStudents": "43/50"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Essay Writing",
    "homework": true,
    "homeworkVal": "Essay Writing",
    "countStudents": "29/49"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Anuchhed",
    "homework": true,
    "homeworkVal": "Patra Lekhan",
    "countStudents": "27/45"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "45/46"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Division",
    "homework": false,
    "homeworkVal": "Multiplication",
    "countStudents": "23/47"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Electricity",
    "countStudents": "38/49"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Civics Duties",
    "homework": true,
    "homeworkVal": "World Wars",
    "countStudents": "30/45"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": false,
    "homeworkVal": "Translation",
    "countStudents": "21/47"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Input Devices",
    "homework": false,
    "homeworkVal": "Input Devices",
    "countStudents": "33/46"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "India States",
    "homework": false,
    "homeworkVal": "Famous Personalities",
    "countStudents": "45/47"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": true,
    "homeworkVal": "Grammar Rules",
    "countStudents": "30/46"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "36/48"
  },
  {
    "date": "20-06-2025",
    "class": "VII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Famous Authors",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "23/48"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "English II",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Grammar",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "24/49"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Hindi I",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Anuchhed",
    "countStudents": "25/45"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Hindi II",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "21/47"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Math",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Geometry",
    "countStudents": "44/49"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Science",
    "teacher": "Nisha Chhetri",
    "classwork": false,
    "classworkVal": "Magnetism",
    "homework": true,
    "homeworkVal": "Human Body",
    "countStudents": "41/46"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Social Science",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Resources",
    "homework": false,
    "homeworkVal": "Civics Duties",
    "countStudents": "35/45"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Sanskrit",
    "teacher": "Mohit Chauhan",
    "classwork": false,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "42/46"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Computer",
    "teacher": "Nisha Chhetri",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "MS Word",
    "countStudents": "23/47"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "G.K.",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "World Facts",
    "homework": true,
    "homeworkVal": "General Knowledge Quiz",
    "countStudents": "37/46"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Basic Vocabulary",
    "homework": true,
    "homeworkVal": "Sentence Formation",
    "countStudents": "27/49"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Cricket",
    "countStudents": "27/48"
  },
  {
    "date": "20-06-2025",
    "class": "VIII-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Silent Reading",
    "countStudents": "43/45"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "41/45"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Nibandh",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "41/47"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Vyakaran",
    "homework": false,
    "homeworkVal": "Nibandh",
    "countStudents": "39/50"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Multiplication",
    "homework": true,
    "homeworkVal": "Fractions",
    "countStudents": "29/50"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": false,
    "classworkVal": "Laws of Motion",
    "homework": false,
    "homeworkVal": "Work and Energy",
    "countStudents": "34/46"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Chemical Reactions",
    "homework": false,
    "homeworkVal": "Acids and Bases",
    "countStudents": "41/47"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Cells",
    "homework": true,
    "homeworkVal": "Nutrition",
    "countStudents": "26/46"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "Mughal Empire",
    "countStudents": "30/47"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Elections",
    "homework": false,
    "homeworkVal": "Democracy",
    "countStudents": "44/47"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Climate",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "35/45"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": false,
    "classworkVal": "Income and Expenditure",
    "homework": false,
    "homeworkVal": "Banking",
    "countStudents": "41/46"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Samas",
    "homework": false,
    "homeworkVal": "Shlok Recitation",
    "countStudents": "29/47"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Internet Safety",
    "homework": true,
    "homeworkVal": "HTML Basics",
    "countStudents": "24/46"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Basic Vocabulary",
    "homework": false,
    "homeworkVal": "Basic Vocabulary",
    "countStudents": "27/50"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Reading Hour",
    "homework": true,
    "homeworkVal": "Library Rules",
    "countStudents": "26/46"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": true,
    "classworkVal": "Yoga",
    "homework": true,
    "homeworkVal": "Warm-up",
    "countStudents": "38/49"
  },
  {
    "date": "20-06-2025",
    "class": "IX-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Instrument Practice",
    "homework": true,
    "homeworkVal": "Practice Raag",
    "countStudents": "28/50"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Poetry Analysis",
    "homework": false,
    "homeworkVal": "Essay Writing",
    "countStudents": "34/46"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": true,
    "homeworkVal": "Kavita",
    "countStudents": "34/50"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "41/45"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Math",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Algebra",
    "homework": false,
    "homeworkVal": "Geometry",
    "countStudents": "27/45"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Work and Energy",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "29/47"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": true,
    "homeworkVal": "Mixtures",
    "countStudents": "36/49"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Respiration",
    "homework": false,
    "homeworkVal": "Nutrition",
    "countStudents": "22/50"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "History",
    "teacher": "Pooja Reddy",
    "classwork": false,
    "classworkVal": "Modern History",
    "homework": false,
    "homeworkVal": "British Rule",
    "countStudents": "45/49"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Civics",
    "teacher": "Pooja Reddy",
    "classwork": true,
    "classworkVal": "Fundamental Rights",
    "homework": false,
    "homeworkVal": "Government",
    "countStudents": "37/46"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Geography",
    "teacher": "Mohit Chauhan",
    "classwork": true,
    "classworkVal": "Landforms",
    "homework": true,
    "homeworkVal": "Agriculture",
    "countStudents": "25/47"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Economics",
    "teacher": "Megha Fernandes",
    "classwork": true,
    "classworkVal": "Money",
    "homework": true,
    "homeworkVal": "Income and Expenditure",
    "countStudents": "42/47"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": false,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "45/50"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "IT",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "HTML Basics",
    "homework": false,
    "homeworkVal": "MS Office",
    "countStudents": "33/50"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Spanish",
    "teacher": "Kiran Phukan",
    "classwork": true,
    "classworkVal": "Greetings",
    "homework": false,
    "homeworkVal": "Sentence Formation",
    "countStudents": "28/46"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Library",
    "teacher": "Kiran Phukan",
    "classwork": false,
    "classworkVal": "Reading Hour",
    "homework": false,
    "homeworkVal": "Silent Reading",
    "countStudents": "20/50"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Sports",
    "teacher": "Rajesh Shetty",
    "classwork": false,
    "classworkVal": "Football",
    "homework": false,
    "homeworkVal": "Football",
    "countStudents": "23/48"
  },
  {
    "date": "20-06-2025",
    "class": "X-A",
    "subject": "Music",
    "teacher": "Gaurav Tiwari",
    "classwork": true,
    "classworkVal": "Bhajan",
    "homework": true,
    "homeworkVal": "Patriotic Song",
    "countStudents": "35/47"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": false,
    "classworkVal": "Literature",
    "homework": false,
    "homeworkVal": "Poetry Analysis",
    "countStudents": "31/45"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Vyakaran",
    "homework": true,
    "homeworkVal": "Nibandh",
    "countStudents": "24/48"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kavita",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "44/49"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Trigonometry",
    "homework": true,
    "homeworkVal": "Calculus",
    "countStudents": "40/49"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Statistics",
    "homework": true,
    "homeworkVal": "Statistics",
    "countStudents": "29/46"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Gravitation",
    "homework": false,
    "homeworkVal": "Light",
    "countStudents": "23/48"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Periodic Table",
    "homework": false,
    "homeworkVal": "Mixtures",
    "countStudents": "22/49"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Reproduction",
    "homework": false,
    "homeworkVal": "Cells",
    "countStudents": "37/47"
  },
  {
    "date": "20-06-2025",
    "class": "XI-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Sandhi",
    "homework": true,
    "homeworkVal": "Sandhi",
    "countStudents": "29/49"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "English II",
    "teacher": "Abhigya Anand",
    "classwork": true,
    "classworkVal": "Drama",
    "homework": true,
    "homeworkVal": "Literature",
    "countStudents": "40/45"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Hindi I",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Patra Lekhan",
    "homework": false,
    "homeworkVal": "Vyakaran",
    "countStudents": "39/45"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Hindi II",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Kahani",
    "homework": true,
    "homeworkVal": "Kahani",
    "countStudents": "35/46"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Maths 1",
    "teacher": "Sachin Sharma",
    "classwork": false,
    "classworkVal": "Geometry",
    "homework": false,
    "homeworkVal": "Calculus",
    "countStudents": "36/45"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Maths 2",
    "teacher": "Sachin Sharma",
    "classwork": true,
    "classworkVal": "Differentiation",
    "homework": true,
    "homeworkVal": "Determinants",
    "countStudents": "24/49"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Physics",
    "teacher": "Simran Nair",
    "classwork": true,
    "classworkVal": "Light",
    "homework": true,
    "homeworkVal": "Gravitation",
    "countStudents": "41/49"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Chemistry",
    "teacher": "Sharad Shukla",
    "classwork": false,
    "classworkVal": "Atoms",
    "homework": false,
    "homeworkVal": "Periodic Table",
    "countStudents": "34/50"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Biology",
    "teacher": "Sharad Shukla",
    "classwork": true,
    "classworkVal": "Diseases",
    "homework": true,
    "homeworkVal": "Diseases",
    "countStudents": "22/49"
  },
  {
    "date": "20-06-2025",
    "class": "XII-A",
    "subject": "Sanskrit",
    "teacher": "Roshini Mathur",
    "classwork": true,
    "classworkVal": "Translation",
    "homework": false,
    "homeworkVal": "Sandhi",
    "countStudents": "37/48"
  }
];
const parseDDMMYYYY = (dateStr) => parse(dateStr, "dd-MM-yyyy", new Date());

const TeacherReportScreen = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [filteredData, setFilteredData] = useState([]);
  const [tableLoader, setTableLoader] = useState('none');
  const [allowAction, setAllowAction] = useState('auto');
  const [filterDt, setFilterDt] = useState('')
  const [filterTch, setFilterTch] = useState('')
  const [filterSub, setFilterSub] = useState('')
  const [filterCls, setFilterCls] = useState('')
  useEffect(() => {
    const today = new Date();
    const past = new Date();
    past.setMonth(today.getMonth() - 3);
    setFromDate(past);
    setToDate(today);
    filterData(past, today);
  }, []);
useEffect(() => {
  applyFilters();
}, [filterCls, filterDt, filterTch, filterSub]);
  
const applyFilters = () => {
  let result = dummyReportData;

  if (filterSub.trim() !== '') {
    result = result.filter(item =>
      item.subject.toLowerCase().includes(filterSub.toLowerCase())
    );
  }

  if (filterTch.trim() !== '') {
    result = result.filter(item =>
      item.teacher.toLowerCase().includes(filterTch.toLowerCase())
    );
  }

  if (filterCls.trim() !== '') {
    result = result.filter(item =>
      item.class.toLowerCase() === filterCls.toLowerCase()
    );
  }

  if (filterDt.trim() !== '') {
    result = result.filter(item =>
      item.date.startsWith(filterDt) // or use better formatting
    );
  }

  setFilteredData(result);
};

  const handleFilterSubject = (e) => {
    const keyword = e.target.value.trim();
    setFilterSub(keyword);
  };
  const handleFilterTeacher = (e) => {
    const keyword = e.target.value.trim();
    setFilterTch(keyword);
  };
  const handleFilterClass = (e) => {
    const keyword = e.target.value.trim();
    setFilterCls(keyword);
  };
  const handleFilterDate = (e) => {
    const keyword = e.target.value.trim();
    setFilterDt(keyword);
  };
  const filterData = (from, to) => {
    setFilterCls('')
    setFilterDt('')
    setFilterSub('')
    setFilterTch('')
    const result = dummyReportData.filter((entry) =>
      isWithinInterval(parseDDMMYYYY(entry.date), {
        start: from,
        end: to,
      })
    );
    setFilteredData(result);
  };

  const handleGetReport = () => {
    filterData(fromDate, toDate);
  };

  const colgrp = <colgroup>
    <col width="10"></col>
    <col width="10"></col>
    <col width="20"></col>
    <col width="30"></col>
    <col width="10"></col>
    <col width="10"></col>
    <col width="15"></col>
  </colgroup>
  return (
    <div style={{ height: '100%' }}>
      <Header />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div className="mainContainer" style={{ pointerEvents: allowAction }}>
        <div className="col-md-11 col-centered wingsWrap clearfix">
          <div className="col-md-9 col-xs-9">
            <div style={{ position: 'absolute', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: tableLoader }}>
              <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            {/* Date Filters */}
            <div style={{ marginBottom: "20px", display: "flex", gap: "15px", alignItems: "flex-end" }}>
              <label>
                From:{" "}
                <DatePicker
                  className='form-control'
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="DD-MM-YYYY"
                />
              </label>
              <label>
                To:{" "}
                <DatePicker
                  className='form-control'
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="DD-MM-YYYY"
                />
              </label>
              <button onClick={handleGetReport} style={buttonStyle} >
                Get Report
              </button>
            </div>

            {/* Table */}
            <table className="tableLayout1" style={{ borderCollapse: "collapse", width: "100%" }}>
              {colgrp}
              <thead>
                <tr style={{ backgroundColor: "#f0f0f0" }}>
                  <th style={thStyle}>
                    <input
                      onChange={handleFilterDate}
                      type="text"
                      value={filterDt}
                      className="form-control inp-search"
                      placeholder="Date" />
                  </th>
                  <th style={thStyle}>
                    <input
                      onChange={handleFilterClass}
                      type="text"
                      value={filterCls}
                      className="form-control inp-search"
                      placeholder="Class" />
                  </th>
                  <th style={thStyle}>
                    <input
                      onChange={handleFilterSubject}
                      type="text"
                      value={filterSub}
                      className="form-control inp-search"
                      placeholder="Subject" />
                  </th>
                  <th style={thStyle}>
                    <input
                      onChange={handleFilterTeacher}
                      type="text"
                      value={filterTch}
                      className="form-control inp-search"
                      placeholder="Teacher" />
                  </th>
                  <th style={thStyle}>Classwork</th>
                  <th style={thStyle}>Homework</th>
                  <th style={thStyle}>Students</th>
                </tr>
              </thead>
            </table>
            <div className="tableDiv" style={{ height: "60vh" }}>
              <table className="tableLayout">
                {colgrp}
                <tbody>
                  {filteredData.map((entry, idx) => (
                    <tr key={idx} style={{ textAlign: "center", borderBottom: "1px solid #ccc" }}>
                      <td style={tdStyle}>{entry.date}</td>
                      <td style={{ ...tdStyle, textAlign: 'left' }}>{entry.class}</td>
                      <td style={{ ...tdStyle, textAlign: 'left' }}>{entry.subject}</td>
                      <td style={{ ...tdStyle, textAlign: 'left' }}>{entry.teacher}</td>
                      <td style={tdStyle}>
                        <span title={entry.classworkVal}>{entry.classwork ? "✅" : "❌"}</span>
                      </td>
                      <td style={tdStyle}>
                        <span title={entry.homeworkVal}>{entry.homework ? "✅" : "❌"}</span>
                      </td>
                      <td style={tdStyle}>{entry.countStudents}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const thStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  fontWeight: "bold",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "8px",
};

const buttonStyle = {
  padding: "6px 12px",
  backgroundColor: "#1976d2",
  color: "#fff",
  margin: 6,
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};

export default TeacherReportScreen;
